/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedAccountingRouteImport } from './routes/_authenticated/accounting'
import { Route as AuthenticatedCamerasRouteRouteImport } from './routes/_authenticated/cameras/route'
import { Route as AuthenticatedCartPhotosX7k2qzRouteImport } from './routes/_authenticated/cart-photos-x7k2qz'
import { Route as AuthenticatedCartVisionChecksRouteImport } from './routes/_authenticated/cart-vision-checks'
import { Route as AuthenticatedCartsRouteImport } from './routes/_authenticated/carts'
import { Route as AuthenticatedCartsControlRouteImport } from './routes/_authenticated/carts-control'
import { Route as AuthenticatedCpiInventoryRouteImport } from './routes/_authenticated/cpi-inventory'
import { Route as AuthenticatedIndustrialConfiguratorRouteImport } from './routes/_authenticated/industrial-configurator'
import { Route as AuthenticatedInventoriesRouteRouteImport } from './routes/_authenticated/inventories/route'
import { Route as AuthenticatedStagingToolsRouteImport } from './routes/_authenticated/staging-tools'
import { Route as AuthenticatedStoreAppPreviewRouteImport } from './routes/_authenticated/store-app-preview'
import { Route as AuthenticatedTodayRouteImport } from './routes/_authenticated/today'
import { Route as NosidebarPlanningRouteImport } from './routes/_nosidebar/planning'
import { Route as AuthenticatedAdministrationAccessRouteImport } from './routes/_authenticated/administration/access'
import { Route as AuthenticatedCamerasViewsIndexRouteImport } from './routes/_authenticated/cameras-views/index'
import { Route as AuthenticatedCamerasViewsNewRouteImport } from './routes/_authenticated/cameras-views/new'
import { Route as AuthenticatedCamerasIndexRouteImport } from './routes/_authenticated/cameras/index'
import { Route as AuthenticatedCamerasConfigRouteImport } from './routes/_authenticated/cameras/config'
import { Route as AuthenticatedCamerasNewRouteImport } from './routes/_authenticated/cameras/new'
import { Route as AuthenticatedCategoriesIndexRouteImport } from './routes/_authenticated/categories/index'
import { Route as AuthenticatedCategoriesBrandsRouteImport } from './routes/_authenticated/categories/brands'
import { Route as AuthenticatedCategoriesCategoriesRouteImport } from './routes/_authenticated/categories/categories'
import { Route as AuthenticatedCategoriesNewRouteImport } from './routes/_authenticated/categories/new'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedCompaniesNewRouteImport } from './routes/_authenticated/companies/new'
import { Route as AuthenticatedControleRuptureIndexRouteImport } from './routes/_authenticated/controle-rupture/index'
import { Route as AuthenticatedCorrectionRupturesIndexRouteImport } from './routes/_authenticated/correction-ruptures/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardHoursRouteImport } from './routes/_authenticated/dashboard/hours'
import { Route as AuthenticatedDevelopmentMapCompareRouteImport } from './routes/_authenticated/development/map-compare'
import { Route as AuthenticatedDevelopmentRealEstateRouteImport } from './routes/_authenticated/development/real-estate'
import { Route as AuthenticatedHrCollaboratorsRouteImport } from './routes/_authenticated/hr/collaborators'
import { Route as AuthenticatedHrInterimAgenciesRouteImport } from './routes/_authenticated/hr/interim-agencies'
import { Route as AuthenticatedHrPlanningRouteImport } from './routes/_authenticated/hr/planning'
import { Route as AuthenticatedHrSmsTrackingRouteImport } from './routes/_authenticated/hr/sms-tracking'
import { Route as AuthenticatedInventoriesStoreIdRouteImport } from './routes/_authenticated/inventories/$storeId'
import { Route as AuthenticatedLogisticsIndexRouteImport } from './routes/_authenticated/logistics/index'
import { Route as AuthenticatedMailingListsIndexRouteImport } from './routes/_authenticated/mailing-lists/index'
import { Route as AuthenticatedMailingListsKeyRouteImport } from './routes/_authenticated/mailing-lists/$key'
import { Route as AuthenticatedNetworkDashboardIndexRouteImport } from './routes/_authenticated/network-dashboard/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedNotificationsIdRouteImport } from './routes/_authenticated/notifications/$id'
import { Route as AuthenticatedNotificationsNewRouteImport } from './routes/_authenticated/notifications/new'
import { Route as AuthenticatedPlatformStocksIndexRouteImport } from './routes/_authenticated/platform-stocks/index'
import { Route as AuthenticatedPreAuthorizationsIndexRouteImport } from './routes/_authenticated/pre-authorizations/index'
import { Route as AuthenticatedPrevisionsCategoriesIndexRouteImport } from './routes/_authenticated/previsions-categories/index'
import { Route as AuthenticatedPrevisionsLongTermeIndexRouteImport } from './routes/_authenticated/previsions-long-terme/index'
import { Route as AuthenticatedPrevisionsProduitsIndexRouteImport } from './routes/_authenticated/previsions-produits/index'
import { Route as AuthenticatedPrevisionsSemaineIndexRouteImport } from './routes/_authenticated/previsions-semaine/index'
import { Route as AuthenticatedPrevisionsIndexRouteImport } from './routes/_authenticated/previsions/index'
import { Route as AuthenticatedProductManagementIndexRouteImport } from './routes/_authenticated/product-management/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedProductsImportRouteImport } from './routes/_authenticated/products/import'
import { Route as AuthenticatedProductsNewRouteImport } from './routes/_authenticated/products/new'
import { Route as AuthenticatedPromoCampaignIndexRouteImport } from './routes/_authenticated/promo-campaign/index'
import { Route as AuthenticatedPromoCampaignNewRouteImport } from './routes/_authenticated/promo-campaign/new'
import { Route as AuthenticatedQualityIndexRouteImport } from './routes/_authenticated/quality/index'
import { Route as AuthenticatedQualityLotRouteImport } from './routes/_authenticated/quality/$lot'
import { Route as AuthenticatedQualityArticlesRouteImport } from './routes/_authenticated/quality/articles'
import { Route as AuthenticatedQualityLotsRouteImport } from './routes/_authenticated/quality/lots'
import { Route as AuthenticatedSandboxPrevisionsIndexRouteImport } from './routes/_authenticated/sandbox-previsions/index'
import { Route as AuthenticatedSellersIndexRouteImport } from './routes/_authenticated/sellers/index'
import { Route as AuthenticatedSellersEstablishmentsRouteImport } from './routes/_authenticated/sellers/establishments'
import { Route as AuthenticatedSellersNewRouteImport } from './routes/_authenticated/sellers/new'
import { Route as AuthenticatedSellersSellersRouteImport } from './routes/_authenticated/sellers/sellers'
import { Route as AuthenticatedSensorsIndexRouteImport } from './routes/_authenticated/sensors/index'
import { Route as AuthenticatedSensorsNewRouteImport } from './routes/_authenticated/sensors/new'
import { Route as AuthenticatedServiceClientIndexRouteImport } from './routes/_authenticated/service-client/index'
import { Route as AuthenticatedStoreAppTodoIndexRouteImport } from './routes/_authenticated/store-app-todo/index'
import { Route as AuthenticatedStoresIndexRouteImport } from './routes/_authenticated/stores/index'
import { Route as AuthenticatedStoresNewRouteImport } from './routes/_authenticated/stores/new'
import { Route as AuthenticatedSupplyIndexRouteImport } from './routes/_authenticated/supply/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedUsersAppRouteImport } from './routes/_authenticated/users/app'
import { Route as AuthenticatedUsersBoRouteImport } from './routes/_authenticated/users/bo'
import { Route as AuthenticatedUsersPaymentDefaultsRouteImport } from './routes/_authenticated/users/payment-defaults'
import { Route as AuthenticatedUsersPaymentLinksRouteImport } from './routes/_authenticated/users/payment-links'
import { Route as AuthenticatedVacancesScolairesIndexRouteImport } from './routes/_authenticated/vacances-scolaires/index'
import { Route as AuthenticatedVisioReviewsIndexRouteImport } from './routes/_authenticated/visio-reviews/index'
import { Route as AuthenticatedVisioReviewsAdminRouteImport } from './routes/_authenticated/visio-reviews/admin'
import { Route as AuthenticatedVisioReviewsBoutiqueRouteImport } from './routes/_authenticated/visio-reviews/boutique'
import { Route as AuthenticatedVisioReviewsEvaluationRouteImport } from './routes/_authenticated/visio-reviews/evaluation'
import { Route as AuthenticatedVisioReviewsGlobalRouteImport } from './routes/_authenticated/visio-reviews/global'
import { Route as AuthenticatedVisioReviewsOperateurRouteImport } from './routes/_authenticated/visio-reviews/operateur'
import { Route as AuthenticatedVisioReviewsVeilleRouteImport } from './routes/_authenticated/visio-reviews/veille'
import { Route as NosidebarWorkshiftAttendanceStoreIdRouteImport } from './routes/_nosidebar/workshift-attendance.$storeId'
import { Route as AuthenticatedAdministrationAdminsNewRouteImport } from './routes/_authenticated/administration/admins/new'
import { Route as AuthenticatedAdministrationRolesIndexRouteImport } from './routes/_authenticated/administration/roles/index'
import { Route as AuthenticatedAdministrationRolesNewRouteImport } from './routes/_authenticated/administration/roles/new'
import { Route as AuthenticatedCamerasViewsViewIdEditRouteImport } from './routes/_authenticated/cameras-views/$viewId.edit'
import { Route as AuthenticatedCategoriesCategoryIdEditRouteImport } from './routes/_authenticated/categories/$categoryId.edit'
import { Route as AuthenticatedCategoriesBrandNewRouteImport } from './routes/_authenticated/categories/brand.new'
import { Route as AuthenticatedCategoriesInternalIndexRouteImport } from './routes/_authenticated/categories/internal.index'
import { Route as AuthenticatedCategoriesInternalNewRouteImport } from './routes/_authenticated/categories/internal.new'
import { Route as AuthenticatedCategoriesReapproIndexRouteImport } from './routes/_authenticated/categories/reappro.index'
import { Route as AuthenticatedCategoriesReapproConfigRouteImport } from './routes/_authenticated/categories/reappro.config'
import { Route as AuthenticatedCategoriesReapproForecastPilotRouteImport } from './routes/_authenticated/categories/reappro.forecast-pilot'
import { Route as AuthenticatedCategoriesReapproNewRouteImport } from './routes/_authenticated/categories/reappro.new'
import { Route as AuthenticatedCompaniesIdEditRouteImport } from './routes/_authenticated/companies/$id.edit'
import { Route as AuthenticatedDevelopmentRealEstateIndexRouteImport } from './routes/_authenticated/development/real-estate.index'
import { Route as AuthenticatedDevelopmentRealEstateCalendarRouteImport } from './routes/_authenticated/development/real-estate.calendar'
import { Route as AuthenticatedDevelopmentRealEstateCartesValideesRouteImport } from './routes/_authenticated/development/real-estate.cartes-validees'
import { Route as AuthenticatedDevelopmentRealEstateContactsRouteImport } from './routes/_authenticated/development/real-estate.contacts'
import { Route as AuthenticatedDevelopmentRealEstateInterestZonesRouteImport } from './routes/_authenticated/development/real-estate.interest-zones'
import { Route as AuthenticatedDevelopmentRealEstateKanbanRouteImport } from './routes/_authenticated/development/real-estate.kanban'
import { Route as AuthenticatedDevelopmentRealEstateMapRouteImport } from './routes/_authenticated/development/real-estate.map'
import { Route as AuthenticatedDevelopmentRealEstateTasksRouteImport } from './routes/_authenticated/development/real-estate.tasks'
import { Route as AuthenticatedHrPlanningIndexRouteImport } from './routes/_authenticated/hr/planning.index'
import { Route as AuthenticatedHrPlanningAbsenceCalendarRouteImport } from './routes/_authenticated/hr/planning.absence-calendar'
import { Route as AuthenticatedHrPlanningAttendanceRouteImport } from './routes/_authenticated/hr/planning.attendance'
import { Route as AuthenticatedHrPlanningCalendarRouteImport } from './routes/_authenticated/hr/planning.calendar'
import { Route as AuthenticatedHrPlanningCollaboratorsRouteImport } from './routes/_authenticated/hr/planning.collaborators'
import { Route as AuthenticatedHrPlanningDashboardRouteImport } from './routes/_authenticated/hr/planning.dashboard'
import { Route as AuthenticatedLogisticsCollaboratorsCollaboratorIdRouteImport } from './routes/_authenticated/logistics/collaborators/$collaboratorId'
import { Route as AuthenticatedLogisticsCollaboratorsNewRouteImport } from './routes/_authenticated/logistics/collaborators/new'
import { Route as AuthenticatedLogisticsHubsHubIdRouteImport } from './routes/_authenticated/logistics/hubs/$hubId'
import { Route as AuthenticatedLogisticsHubsNewRouteImport } from './routes/_authenticated/logistics/hubs/new'
import { Route as AuthenticatedLogisticsSimulationsSimulationIdRouteImport } from './routes/_authenticated/logistics/simulations/$simulationId'
import { Route as AuthenticatedLogisticsVehiclesVehicleIdRouteImport } from './routes/_authenticated/logistics/vehicles/$vehicleId'
import { Route as AuthenticatedLogisticsVehiclesNewRouteImport } from './routes/_authenticated/logistics/vehicles/new'
import { Route as AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport } from './routes/_authenticated/pre-authorizations/$sessionId.recordings'
import { Route as AuthenticatedProductsProductIdIndexRouteImport } from './routes/_authenticated/products/$productId.index'
import { Route as AuthenticatedProductsProductIdEditRouteImport } from './routes/_authenticated/products/$productId.edit'
import { Route as AuthenticatedSellersSellerIdEditRouteImport } from './routes/_authenticated/sellers/$sellerId.edit'
import { Route as AuthenticatedSellersEstablishmentNewRouteImport } from './routes/_authenticated/sellers/establishment.new'
import { Route as AuthenticatedSensorsFridgeNewRouteImport } from './routes/_authenticated/sensors/fridge.new'
import { Route as AuthenticatedServiceClientTicketsIdRouteImport } from './routes/_authenticated/service-client/tickets/$id'
import { Route as AuthenticatedStoresStoreIdIndexRouteImport } from './routes/_authenticated/stores/$storeId.index'
import { Route as AuthenticatedStoresStoreIdDetailsRouteImport } from './routes/_authenticated/stores/$storeId.details'
import { Route as AuthenticatedStoresStoreIdHoursRouteImport } from './routes/_authenticated/stores/$storeId.hours'
import { Route as AuthenticatedStoresStoreIdInventoryRouteImport } from './routes/_authenticated/stores/$storeId.inventory'
import { Route as AuthenticatedStoresStoreIdKiosksRouteImport } from './routes/_authenticated/stores/$storeId.kiosks'
import { Route as AuthenticatedStoresStoreIdStatsRouteImport } from './routes/_authenticated/stores/$storeId.stats'
import { Route as AuthenticatedUsersEditUserIdRouteImport } from './routes/_authenticated/users/edit/$userId'
import { Route as AuthenticatedAdministrationAdminsIdEditRouteImport } from './routes/_authenticated/administration/admins/$id.edit'
import { Route as AuthenticatedAdministrationRolesRoleIdIndexRouteImport } from './routes/_authenticated/administration/roles/$roleId.index'
import { Route as AuthenticatedAdministrationRolesRoleIdEditRouteImport } from './routes/_authenticated/administration/roles/$roleId.edit'
import { Route as AuthenticatedCategoriesBrandBrandIdEditRouteImport } from './routes/_authenticated/categories/brand.$brandId.edit'
import { Route as AuthenticatedCategoriesReapproForecastPilotDailyReviewRouteImport } from './routes/_authenticated/categories/reappro.forecast-pilot_.daily-review'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId'
import { Route as AuthenticatedHrPlanningCollaboratorsCollaboratorIdRouteImport } from './routes/_authenticated/hr/planning.collaborators.$collaboratorId'
import { Route as AuthenticatedSellersEstablishmentEstablishmentIdEditRouteImport } from './routes/_authenticated/sellers/establishment.$establishmentId.edit'
import { Route as AuthenticatedStoresStoreIdInventoriesIndexRouteImport } from './routes/_authenticated/stores/$storeId.inventories.index'
import { Route as AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport } from './routes/_authenticated/stores/$storeId.inventories.$inventoryId'
import { Route as AuthenticatedStoresStoreIdStocksIndexRouteImport } from './routes/_authenticated/stores/$storeId.stocks.index'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.index'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.admin-authorizations'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.analytics'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.documents'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.general'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.land-commitment'
import { Route as AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRouteImport } from './routes/_authenticated/development/real-estate.kanban.$cardId.works'
import { Route as AuthenticatedStoresStoreIdStocksProductProductIdRouteImport } from './routes/_authenticated/stores/$storeId.stocks.product.$productId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountingRoute = AuthenticatedAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCamerasRouteRoute =
  AuthenticatedCamerasRouteRouteImport.update({
    id: '/cameras',
    path: '/cameras',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartPhotosX7k2qzRoute =
  AuthenticatedCartPhotosX7k2qzRouteImport.update({
    id: '/cart-photos-x7k2qz',
    path: '/cart-photos-x7k2qz',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartVisionChecksRoute =
  AuthenticatedCartVisionChecksRouteImport.update({
    id: '/cart-vision-checks',
    path: '/cart-vision-checks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartsRoute = AuthenticatedCartsRouteImport.update({
  id: '/carts',
  path: '/carts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCartsControlRoute =
  AuthenticatedCartsControlRouteImport.update({
    id: '/carts-control',
    path: '/carts-control',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCpiInventoryRoute =
  AuthenticatedCpiInventoryRouteImport.update({
    id: '/cpi-inventory',
    path: '/cpi-inventory',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIndustrialConfiguratorRoute =
  AuthenticatedIndustrialConfiguratorRouteImport.update({
    id: '/industrial-configurator',
    path: '/industrial-configurator',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoriesRouteRoute =
  AuthenticatedInventoriesRouteRouteImport.update({
    id: '/inventories',
    path: '/inventories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStagingToolsRoute =
  AuthenticatedStagingToolsRouteImport.update({
    id: '/staging-tools',
    path: '/staging-tools',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoreAppPreviewRoute =
  AuthenticatedStoreAppPreviewRouteImport.update({
    id: '/store-app-preview',
    path: '/store-app-preview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTodayRoute = AuthenticatedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const NosidebarPlanningRoute = NosidebarPlanningRouteImport.update({
  id: '/_nosidebar/planning',
  path: '/planning',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdministrationAccessRoute =
  AuthenticatedAdministrationAccessRouteImport.update({
    id: '/administration/access',
    path: '/administration/access',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasViewsIndexRoute =
  AuthenticatedCamerasViewsIndexRouteImport.update({
    id: '/cameras-views/',
    path: '/cameras-views/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasViewsNewRoute =
  AuthenticatedCamerasViewsNewRouteImport.update({
    id: '/cameras-views/new',
    path: '/cameras-views/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasIndexRoute =
  AuthenticatedCamerasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCamerasRouteRoute,
  } as any)
const AuthenticatedCamerasConfigRoute =
  AuthenticatedCamerasConfigRouteImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => AuthenticatedCamerasRouteRoute,
  } as any)
const AuthenticatedCamerasNewRoute = AuthenticatedCamerasNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedCamerasRouteRoute,
} as any)
const AuthenticatedCategoriesIndexRoute =
  AuthenticatedCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesBrandsRoute =
  AuthenticatedCategoriesBrandsRouteImport.update({
    id: '/categories/brands',
    path: '/categories/brands',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesCategoriesRoute =
  AuthenticatedCategoriesCategoriesRouteImport.update({
    id: '/categories/categories',
    path: '/categories/categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesNewRoute =
  AuthenticatedCategoriesNewRouteImport.update({
    id: '/categories/new',
    path: '/categories/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesNewRoute =
  AuthenticatedCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedControleRuptureIndexRoute =
  AuthenticatedControleRuptureIndexRouteImport.update({
    id: '/controle-rupture/',
    path: '/controle-rupture/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCorrectionRupturesIndexRoute =
  AuthenticatedCorrectionRupturesIndexRouteImport.update({
    id: '/correction-ruptures/',
    path: '/correction-ruptures/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHoursRoute =
  AuthenticatedDashboardHoursRouteImport.update({
    id: '/dashboard/hours',
    path: '/dashboard/hours',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentMapCompareRoute =
  AuthenticatedDevelopmentMapCompareRouteImport.update({
    id: '/development/map-compare',
    path: '/development/map-compare',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateRoute =
  AuthenticatedDevelopmentRealEstateRouteImport.update({
    id: '/development/real-estate',
    path: '/development/real-estate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrCollaboratorsRoute =
  AuthenticatedHrCollaboratorsRouteImport.update({
    id: '/hr/collaborators',
    path: '/hr/collaborators',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrInterimAgenciesRoute =
  AuthenticatedHrInterimAgenciesRouteImport.update({
    id: '/hr/interim-agencies',
    path: '/hr/interim-agencies',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrPlanningRoute = AuthenticatedHrPlanningRouteImport.update({
  id: '/hr/planning',
  path: '/hr/planning',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedHrSmsTrackingRoute =
  AuthenticatedHrSmsTrackingRouteImport.update({
    id: '/hr/sms-tracking',
    path: '/hr/sms-tracking',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoriesStoreIdRoute =
  AuthenticatedInventoriesStoreIdRouteImport.update({
    id: '/$storeId',
    path: '/$storeId',
    getParentRoute: () => AuthenticatedInventoriesRouteRoute,
  } as any)
const AuthenticatedLogisticsIndexRoute =
  AuthenticatedLogisticsIndexRouteImport.update({
    id: '/logistics/',
    path: '/logistics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMailingListsIndexRoute =
  AuthenticatedMailingListsIndexRouteImport.update({
    id: '/mailing-lists/',
    path: '/mailing-lists/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMailingListsKeyRoute =
  AuthenticatedMailingListsKeyRouteImport.update({
    id: '/mailing-lists/$key',
    path: '/mailing-lists/$key',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNetworkDashboardIndexRoute =
  AuthenticatedNetworkDashboardIndexRouteImport.update({
    id: '/network-dashboard/',
    path: '/network-dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsIdRoute =
  AuthenticatedNotificationsIdRouteImport.update({
    id: '/notifications/$id',
    path: '/notifications/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsNewRoute =
  AuthenticatedNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlatformStocksIndexRoute =
  AuthenticatedPlatformStocksIndexRouteImport.update({
    id: '/platform-stocks/',
    path: '/platform-stocks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPreAuthorizationsIndexRoute =
  AuthenticatedPreAuthorizationsIndexRouteImport.update({
    id: '/pre-authorizations/',
    path: '/pre-authorizations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrevisionsCategoriesIndexRoute =
  AuthenticatedPrevisionsCategoriesIndexRouteImport.update({
    id: '/previsions-categories/',
    path: '/previsions-categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrevisionsLongTermeIndexRoute =
  AuthenticatedPrevisionsLongTermeIndexRouteImport.update({
    id: '/previsions-long-terme/',
    path: '/previsions-long-terme/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrevisionsProduitsIndexRoute =
  AuthenticatedPrevisionsProduitsIndexRouteImport.update({
    id: '/previsions-produits/',
    path: '/previsions-produits/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrevisionsSemaineIndexRoute =
  AuthenticatedPrevisionsSemaineIndexRouteImport.update({
    id: '/previsions-semaine/',
    path: '/previsions-semaine/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrevisionsIndexRoute =
  AuthenticatedPrevisionsIndexRouteImport.update({
    id: '/previsions/',
    path: '/previsions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductManagementIndexRoute =
  AuthenticatedProductManagementIndexRouteImport.update({
    id: '/product-management/',
    path: '/product-management/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsImportRoute =
  AuthenticatedProductsImportRouteImport.update({
    id: '/products/import',
    path: '/products/import',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsNewRoute =
  AuthenticatedProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromoCampaignIndexRoute =
  AuthenticatedPromoCampaignIndexRouteImport.update({
    id: '/promo-campaign/',
    path: '/promo-campaign/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromoCampaignNewRoute =
  AuthenticatedPromoCampaignNewRouteImport.update({
    id: '/promo-campaign/new',
    path: '/promo-campaign/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQualityIndexRoute =
  AuthenticatedQualityIndexRouteImport.update({
    id: '/quality/',
    path: '/quality/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQualityLotRoute = AuthenticatedQualityLotRouteImport.update({
  id: '/quality/$lot',
  path: '/quality/$lot',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedQualityArticlesRoute =
  AuthenticatedQualityArticlesRouteImport.update({
    id: '/quality/articles',
    path: '/quality/articles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQualityLotsRoute =
  AuthenticatedQualityLotsRouteImport.update({
    id: '/quality/lots',
    path: '/quality/lots',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSandboxPrevisionsIndexRoute =
  AuthenticatedSandboxPrevisionsIndexRouteImport.update({
    id: '/sandbox-previsions/',
    path: '/sandbox-previsions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersIndexRoute =
  AuthenticatedSellersIndexRouteImport.update({
    id: '/sellers/',
    path: '/sellers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersEstablishmentsRoute =
  AuthenticatedSellersEstablishmentsRouteImport.update({
    id: '/sellers/establishments',
    path: '/sellers/establishments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersNewRoute = AuthenticatedSellersNewRouteImport.update({
  id: '/sellers/new',
  path: '/sellers/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSellersSellersRoute =
  AuthenticatedSellersSellersRouteImport.update({
    id: '/sellers/sellers',
    path: '/sellers/sellers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSensorsIndexRoute =
  AuthenticatedSensorsIndexRouteImport.update({
    id: '/sensors/',
    path: '/sensors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSensorsNewRoute = AuthenticatedSensorsNewRouteImport.update({
  id: '/sensors/new',
  path: '/sensors/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedServiceClientIndexRoute =
  AuthenticatedServiceClientIndexRouteImport.update({
    id: '/service-client/',
    path: '/service-client/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoreAppTodoIndexRoute =
  AuthenticatedStoreAppTodoIndexRouteImport.update({
    id: '/store-app-todo/',
    path: '/store-app-todo/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresIndexRoute =
  AuthenticatedStoresIndexRouteImport.update({
    id: '/stores/',
    path: '/stores/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresNewRoute = AuthenticatedStoresNewRouteImport.update({
  id: '/stores/new',
  path: '/stores/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSupplyIndexRoute =
  AuthenticatedSupplyIndexRouteImport.update({
    id: '/supply/',
    path: '/supply/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersAppRoute = AuthenticatedUsersAppRouteImport.update({
  id: '/users/app',
  path: '/users/app',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersBoRoute = AuthenticatedUsersBoRouteImport.update({
  id: '/users/bo',
  path: '/users/bo',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersPaymentDefaultsRoute =
  AuthenticatedUsersPaymentDefaultsRouteImport.update({
    id: '/users/payment-defaults',
    path: '/users/payment-defaults',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersPaymentLinksRoute =
  AuthenticatedUsersPaymentLinksRouteImport.update({
    id: '/users/payment-links',
    path: '/users/payment-links',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVacancesScolairesIndexRoute =
  AuthenticatedVacancesScolairesIndexRouteImport.update({
    id: '/vacances-scolaires/',
    path: '/vacances-scolaires/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsIndexRoute =
  AuthenticatedVisioReviewsIndexRouteImport.update({
    id: '/visio-reviews/',
    path: '/visio-reviews/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsAdminRoute =
  AuthenticatedVisioReviewsAdminRouteImport.update({
    id: '/visio-reviews/admin',
    path: '/visio-reviews/admin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsBoutiqueRoute =
  AuthenticatedVisioReviewsBoutiqueRouteImport.update({
    id: '/visio-reviews/boutique',
    path: '/visio-reviews/boutique',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsEvaluationRoute =
  AuthenticatedVisioReviewsEvaluationRouteImport.update({
    id: '/visio-reviews/evaluation',
    path: '/visio-reviews/evaluation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsGlobalRoute =
  AuthenticatedVisioReviewsGlobalRouteImport.update({
    id: '/visio-reviews/global',
    path: '/visio-reviews/global',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsOperateurRoute =
  AuthenticatedVisioReviewsOperateurRouteImport.update({
    id: '/visio-reviews/operateur',
    path: '/visio-reviews/operateur',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsVeilleRoute =
  AuthenticatedVisioReviewsVeilleRouteImport.update({
    id: '/visio-reviews/veille',
    path: '/visio-reviews/veille',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const NosidebarWorkshiftAttendanceStoreIdRoute =
  NosidebarWorkshiftAttendanceStoreIdRouteImport.update({
    id: '/_nosidebar/workshift-attendance/$storeId',
    path: '/workshift-attendance/$storeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedAdministrationAdminsNewRoute =
  AuthenticatedAdministrationAdminsNewRouteImport.update({
    id: '/administration/admins/new',
    path: '/administration/admins/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesIndexRoute =
  AuthenticatedAdministrationRolesIndexRouteImport.update({
    id: '/administration/roles/',
    path: '/administration/roles/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesNewRoute =
  AuthenticatedAdministrationRolesNewRouteImport.update({
    id: '/administration/roles/new',
    path: '/administration/roles/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasViewsViewIdEditRoute =
  AuthenticatedCamerasViewsViewIdEditRouteImport.update({
    id: '/cameras-views/$viewId/edit',
    path: '/cameras-views/$viewId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesCategoryIdEditRoute =
  AuthenticatedCategoriesCategoryIdEditRouteImport.update({
    id: '/categories/$categoryId/edit',
    path: '/categories/$categoryId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesBrandNewRoute =
  AuthenticatedCategoriesBrandNewRouteImport.update({
    id: '/categories/brand/new',
    path: '/categories/brand/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesInternalIndexRoute =
  AuthenticatedCategoriesInternalIndexRouteImport.update({
    id: '/categories/internal/',
    path: '/categories/internal/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesInternalNewRoute =
  AuthenticatedCategoriesInternalNewRouteImport.update({
    id: '/categories/internal/new',
    path: '/categories/internal/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproIndexRoute =
  AuthenticatedCategoriesReapproIndexRouteImport.update({
    id: '/categories/reappro/',
    path: '/categories/reappro/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproConfigRoute =
  AuthenticatedCategoriesReapproConfigRouteImport.update({
    id: '/categories/reappro/config',
    path: '/categories/reappro/config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproForecastPilotRoute =
  AuthenticatedCategoriesReapproForecastPilotRouteImport.update({
    id: '/categories/reappro/forecast-pilot',
    path: '/categories/reappro/forecast-pilot',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproNewRoute =
  AuthenticatedCategoriesReapproNewRouteImport.update({
    id: '/categories/reappro/new',
    path: '/categories/reappro/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesIdEditRoute =
  AuthenticatedCompaniesIdEditRouteImport.update({
    id: '/companies/$id/edit',
    path: '/companies/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateIndexRoute =
  AuthenticatedDevelopmentRealEstateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateCalendarRoute =
  AuthenticatedDevelopmentRealEstateCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateCartesValideesRoute =
  AuthenticatedDevelopmentRealEstateCartesValideesRouteImport.update({
    id: '/cartes-validees',
    path: '/cartes-validees',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateContactsRoute =
  AuthenticatedDevelopmentRealEstateContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateInterestZonesRoute =
  AuthenticatedDevelopmentRealEstateInterestZonesRouteImport.update({
    id: '/interest-zones',
    path: '/interest-zones',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanRoute =
  AuthenticatedDevelopmentRealEstateKanbanRouteImport.update({
    id: '/kanban',
    path: '/kanban',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateMapRoute =
  AuthenticatedDevelopmentRealEstateMapRouteImport.update({
    id: '/map',
    path: '/map',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateTasksRoute =
  AuthenticatedDevelopmentRealEstateTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateRoute,
  } as any)
const AuthenticatedHrPlanningIndexRoute =
  AuthenticatedHrPlanningIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedHrPlanningAbsenceCalendarRoute =
  AuthenticatedHrPlanningAbsenceCalendarRouteImport.update({
    id: '/absence-calendar',
    path: '/absence-calendar',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedHrPlanningAttendanceRoute =
  AuthenticatedHrPlanningAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedHrPlanningCalendarRoute =
  AuthenticatedHrPlanningCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedHrPlanningCollaboratorsRoute =
  AuthenticatedHrPlanningCollaboratorsRouteImport.update({
    id: '/collaborators',
    path: '/collaborators',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedHrPlanningDashboardRoute =
  AuthenticatedHrPlanningDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedHrPlanningRoute,
  } as any)
const AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute =
  AuthenticatedLogisticsCollaboratorsCollaboratorIdRouteImport.update({
    id: '/logistics/collaborators/$collaboratorId',
    path: '/logistics/collaborators/$collaboratorId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsCollaboratorsNewRoute =
  AuthenticatedLogisticsCollaboratorsNewRouteImport.update({
    id: '/logistics/collaborators/new',
    path: '/logistics/collaborators/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsHubsHubIdRoute =
  AuthenticatedLogisticsHubsHubIdRouteImport.update({
    id: '/logistics/hubs/$hubId',
    path: '/logistics/hubs/$hubId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsHubsNewRoute =
  AuthenticatedLogisticsHubsNewRouteImport.update({
    id: '/logistics/hubs/new',
    path: '/logistics/hubs/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsSimulationsSimulationIdRoute =
  AuthenticatedLogisticsSimulationsSimulationIdRouteImport.update({
    id: '/logistics/simulations/$simulationId',
    path: '/logistics/simulations/$simulationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsVehiclesVehicleIdRoute =
  AuthenticatedLogisticsVehiclesVehicleIdRouteImport.update({
    id: '/logistics/vehicles/$vehicleId',
    path: '/logistics/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLogisticsVehiclesNewRoute =
  AuthenticatedLogisticsVehiclesNewRouteImport.update({
    id: '/logistics/vehicles/new',
    path: '/logistics/vehicles/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPreAuthorizationsSessionIdRecordingsRoute =
  AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport.update({
    id: '/pre-authorizations/$sessionId/recordings',
    path: '/pre-authorizations/$sessionId/recordings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsProductIdIndexRoute =
  AuthenticatedProductsProductIdIndexRouteImport.update({
    id: '/products/$productId/',
    path: '/products/$productId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsProductIdEditRoute =
  AuthenticatedProductsProductIdEditRouteImport.update({
    id: '/products/$productId/edit',
    path: '/products/$productId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersSellerIdEditRoute =
  AuthenticatedSellersSellerIdEditRouteImport.update({
    id: '/sellers/$sellerId/edit',
    path: '/sellers/$sellerId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersEstablishmentNewRoute =
  AuthenticatedSellersEstablishmentNewRouteImport.update({
    id: '/sellers/establishment/new',
    path: '/sellers/establishment/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSensorsFridgeNewRoute =
  AuthenticatedSensorsFridgeNewRouteImport.update({
    id: '/sensors/fridge/new',
    path: '/sensors/fridge/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedServiceClientTicketsIdRoute =
  AuthenticatedServiceClientTicketsIdRouteImport.update({
    id: '/service-client/tickets/$id',
    path: '/service-client/tickets/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdIndexRoute =
  AuthenticatedStoresStoreIdIndexRouteImport.update({
    id: '/stores/$storeId/',
    path: '/stores/$storeId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdDetailsRoute =
  AuthenticatedStoresStoreIdDetailsRouteImport.update({
    id: '/stores/$storeId/details',
    path: '/stores/$storeId/details',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdHoursRoute =
  AuthenticatedStoresStoreIdHoursRouteImport.update({
    id: '/stores/$storeId/hours',
    path: '/stores/$storeId/hours',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdInventoryRoute =
  AuthenticatedStoresStoreIdInventoryRouteImport.update({
    id: '/stores/$storeId/inventory',
    path: '/stores/$storeId/inventory',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdKiosksRoute =
  AuthenticatedStoresStoreIdKiosksRouteImport.update({
    id: '/stores/$storeId/kiosks',
    path: '/stores/$storeId/kiosks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdStatsRoute =
  AuthenticatedStoresStoreIdStatsRouteImport.update({
    id: '/stores/$storeId/stats',
    path: '/stores/$storeId/stats',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersEditUserIdRoute =
  AuthenticatedUsersEditUserIdRouteImport.update({
    id: '/users/edit/$userId',
    path: '/users/edit/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationAdminsIdEditRoute =
  AuthenticatedAdministrationAdminsIdEditRouteImport.update({
    id: '/administration/admins/$id/edit',
    path: '/administration/admins/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesRoleIdIndexRoute =
  AuthenticatedAdministrationRolesRoleIdIndexRouteImport.update({
    id: '/administration/roles/$roleId/',
    path: '/administration/roles/$roleId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesRoleIdEditRoute =
  AuthenticatedAdministrationRolesRoleIdEditRouteImport.update({
    id: '/administration/roles/$roleId/edit',
    path: '/administration/roles/$roleId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesBrandBrandIdEditRoute =
  AuthenticatedCategoriesBrandBrandIdEditRouteImport.update({
    id: '/categories/brand/$brandId/edit',
    path: '/categories/brand/$brandId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute =
  AuthenticatedCategoriesReapproForecastPilotDailyReviewRouteImport.update({
    id: '/categories/reappro/forecast-pilot_/daily-review',
    path: '/categories/reappro/forecast-pilot/daily-review',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdRouteImport.update({
    id: '/$cardId',
    path: '/$cardId',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanRoute,
  } as any)
const AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute =
  AuthenticatedHrPlanningCollaboratorsCollaboratorIdRouteImport.update({
    id: '/$collaboratorId',
    path: '/$collaboratorId',
    getParentRoute: () => AuthenticatedHrPlanningCollaboratorsRoute,
  } as any)
const AuthenticatedSellersEstablishmentEstablishmentIdEditRoute =
  AuthenticatedSellersEstablishmentEstablishmentIdEditRouteImport.update({
    id: '/sellers/establishment/$establishmentId/edit',
    path: '/sellers/establishment/$establishmentId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdInventoriesIndexRoute =
  AuthenticatedStoresStoreIdInventoriesIndexRouteImport.update({
    id: '/stores/$storeId/inventories/',
    path: '/stores/$storeId/inventories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdInventoriesInventoryIdRoute =
  AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport.update({
    id: '/stores/$storeId/inventories/$inventoryId',
    path: '/stores/$storeId/inventories/$inventoryId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdStocksIndexRoute =
  AuthenticatedStoresStoreIdStocksIndexRouteImport.update({
    id: '/stores/$storeId/stocks/',
    path: '/stores/$storeId/stocks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRouteImport.update(
    {
      id: '/admin-authorizations',
      path: '/admin-authorizations',
      getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
    } as any,
  )
const AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRouteImport.update(
    {
      id: '/land-commitment',
      path: '/land-commitment',
      getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
    } as any,
  )
const AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute =
  AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRouteImport.update({
    id: '/works',
    path: '/works',
    getParentRoute: () => AuthenticatedDevelopmentRealEstateKanbanCardIdRoute,
  } as any)
const AuthenticatedStoresStoreIdStocksProductProductIdRoute =
  AuthenticatedStoresStoreIdStocksProductProductIdRouteImport.update({
    id: '/stores/$storeId/stocks/product/$productId',
    path: '/stores/$storeId/stocks/product/$productId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/cameras': typeof AuthenticatedCamerasRouteRouteWithChildren
  '/inventories': typeof AuthenticatedInventoriesRouteRouteWithChildren
  '/accounting': typeof AuthenticatedAccountingRoute
  '/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/carts': typeof AuthenticatedCartsRoute
  '/carts-control': typeof AuthenticatedCartsControlRoute
  '/cpi-inventory': typeof AuthenticatedCpiInventoryRoute
  '/industrial-configurator': typeof AuthenticatedIndustrialConfiguratorRoute
  '/staging-tools': typeof AuthenticatedStagingToolsRoute
  '/store-app-preview': typeof AuthenticatedStoreAppPreviewRoute
  '/today': typeof AuthenticatedTodayRoute
  '/planning': typeof NosidebarPlanningRoute
  '/administration/access': typeof AuthenticatedAdministrationAccessRoute
  '/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/cameras/new': typeof AuthenticatedCamerasNewRoute
  '/categories/brands': typeof AuthenticatedCategoriesBrandsRoute
  '/categories/categories': typeof AuthenticatedCategoriesCategoriesRoute
  '/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/development/map-compare': typeof AuthenticatedDevelopmentMapCompareRoute
  '/development/real-estate': typeof AuthenticatedDevelopmentRealEstateRouteWithChildren
  '/hr/collaborators': typeof AuthenticatedHrCollaboratorsRoute
  '/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/hr/planning': typeof AuthenticatedHrPlanningRouteWithChildren
  '/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/inventories/$storeId': typeof AuthenticatedInventoriesStoreIdRoute
  '/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/products/import': typeof AuthenticatedProductsImportRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/quality/articles': typeof AuthenticatedQualityArticlesRoute
  '/quality/lots': typeof AuthenticatedQualityLotsRoute
  '/sellers/establishments': typeof AuthenticatedSellersEstablishmentsRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/sellers/sellers': typeof AuthenticatedSellersSellersRoute
  '/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/stores/new': typeof AuthenticatedStoresNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/app': typeof AuthenticatedUsersAppRoute
  '/users/bo': typeof AuthenticatedUsersBoRoute
  '/users/payment-defaults': typeof AuthenticatedUsersPaymentDefaultsRoute
  '/users/payment-links': typeof AuthenticatedUsersPaymentLinksRoute
  '/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/visio-reviews/boutique': typeof AuthenticatedVisioReviewsBoutiqueRoute
  '/visio-reviews/evaluation': typeof AuthenticatedVisioReviewsEvaluationRoute
  '/visio-reviews/global': typeof AuthenticatedVisioReviewsGlobalRoute
  '/visio-reviews/operateur': typeof AuthenticatedVisioReviewsOperateurRoute
  '/visio-reviews/veille': typeof AuthenticatedVisioReviewsVeilleRoute
  '/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/cameras-views/': typeof AuthenticatedCamerasViewsIndexRoute
  '/cameras/': typeof AuthenticatedCamerasIndexRoute
  '/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/controle-rupture/': typeof AuthenticatedControleRuptureIndexRoute
  '/correction-ruptures/': typeof AuthenticatedCorrectionRupturesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/logistics/': typeof AuthenticatedLogisticsIndexRoute
  '/mailing-lists/': typeof AuthenticatedMailingListsIndexRoute
  '/network-dashboard/': typeof AuthenticatedNetworkDashboardIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/platform-stocks/': typeof AuthenticatedPlatformStocksIndexRoute
  '/pre-authorizations/': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/previsions-categories/': typeof AuthenticatedPrevisionsCategoriesIndexRoute
  '/previsions-long-terme/': typeof AuthenticatedPrevisionsLongTermeIndexRoute
  '/previsions-produits/': typeof AuthenticatedPrevisionsProduitsIndexRoute
  '/previsions-semaine/': typeof AuthenticatedPrevisionsSemaineIndexRoute
  '/previsions/': typeof AuthenticatedPrevisionsIndexRoute
  '/product-management/': typeof AuthenticatedProductManagementIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/promo-campaign/': typeof AuthenticatedPromoCampaignIndexRoute
  '/quality/': typeof AuthenticatedQualityIndexRoute
  '/sandbox-previsions/': typeof AuthenticatedSandboxPrevisionsIndexRoute
  '/sellers/': typeof AuthenticatedSellersIndexRoute
  '/sensors/': typeof AuthenticatedSensorsIndexRoute
  '/service-client/': typeof AuthenticatedServiceClientIndexRoute
  '/store-app-todo/': typeof AuthenticatedStoreAppTodoIndexRoute
  '/stores/': typeof AuthenticatedStoresIndexRoute
  '/supply/': typeof AuthenticatedSupplyIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/vacances-scolaires/': typeof AuthenticatedVacancesScolairesIndexRoute
  '/visio-reviews/': typeof AuthenticatedVisioReviewsIndexRoute
  '/administration/admins/new': typeof AuthenticatedAdministrationAdminsNewRoute
  '/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/categories/$categoryId/edit': typeof AuthenticatedCategoriesCategoryIdEditRoute
  '/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/categories/reappro/forecast-pilot': typeof AuthenticatedCategoriesReapproForecastPilotRoute
  '/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/development/real-estate/calendar': typeof AuthenticatedDevelopmentRealEstateCalendarRoute
  '/development/real-estate/cartes-validees': typeof AuthenticatedDevelopmentRealEstateCartesValideesRoute
  '/development/real-estate/contacts': typeof AuthenticatedDevelopmentRealEstateContactsRoute
  '/development/real-estate/interest-zones': typeof AuthenticatedDevelopmentRealEstateInterestZonesRoute
  '/development/real-estate/kanban': typeof AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren
  '/development/real-estate/map': typeof AuthenticatedDevelopmentRealEstateMapRoute
  '/development/real-estate/tasks': typeof AuthenticatedDevelopmentRealEstateTasksRoute
  '/hr/planning/absence-calendar': typeof AuthenticatedHrPlanningAbsenceCalendarRoute
  '/hr/planning/attendance': typeof AuthenticatedHrPlanningAttendanceRoute
  '/hr/planning/calendar': typeof AuthenticatedHrPlanningCalendarRoute
  '/hr/planning/collaborators': typeof AuthenticatedHrPlanningCollaboratorsRouteWithChildren
  '/hr/planning/dashboard': typeof AuthenticatedHrPlanningDashboardRoute
  '/logistics/collaborators/$collaboratorId': typeof AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute
  '/logistics/collaborators/new': typeof AuthenticatedLogisticsCollaboratorsNewRoute
  '/logistics/hubs/$hubId': typeof AuthenticatedLogisticsHubsHubIdRoute
  '/logistics/hubs/new': typeof AuthenticatedLogisticsHubsNewRoute
  '/logistics/simulations/$simulationId': typeof AuthenticatedLogisticsSimulationsSimulationIdRoute
  '/logistics/vehicles/$vehicleId': typeof AuthenticatedLogisticsVehiclesVehicleIdRoute
  '/logistics/vehicles/new': typeof AuthenticatedLogisticsVehiclesNewRoute
  '/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/service-client/tickets/$id': typeof AuthenticatedServiceClientTicketsIdRoute
  '/stores/$storeId/details': typeof AuthenticatedStoresStoreIdDetailsRoute
  '/stores/$storeId/hours': typeof AuthenticatedStoresStoreIdHoursRoute
  '/stores/$storeId/inventory': typeof AuthenticatedStoresStoreIdInventoryRoute
  '/stores/$storeId/kiosks': typeof AuthenticatedStoresStoreIdKiosksRoute
  '/stores/$storeId/stats': typeof AuthenticatedStoresStoreIdStatsRoute
  '/users/edit/$userId': typeof AuthenticatedUsersEditUserIdRoute
  '/administration/roles/': typeof AuthenticatedAdministrationRolesIndexRoute
  '/categories/internal/': typeof AuthenticatedCategoriesInternalIndexRoute
  '/categories/reappro/': typeof AuthenticatedCategoriesReapproIndexRoute
  '/development/real-estate/': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/hr/planning/': typeof AuthenticatedHrPlanningIndexRoute
  '/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/stores/$storeId/': typeof AuthenticatedStoresStoreIdIndexRoute
  '/administration/admins/$id/edit': typeof AuthenticatedAdministrationAdminsIdEditRoute
  '/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/categories/brand/$brandId/edit': typeof AuthenticatedCategoriesBrandBrandIdEditRoute
  '/categories/reappro/forecast-pilot/daily-review': typeof AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute
  '/development/real-estate/kanban/$cardId': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRouteWithChildren
  '/hr/planning/collaborators/$collaboratorId': typeof AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute
  '/sellers/establishment/$establishmentId/edit': typeof AuthenticatedSellersEstablishmentEstablishmentIdEditRoute
  '/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/administration/roles/$roleId/': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
  '/stores/$storeId/inventories/': typeof AuthenticatedStoresStoreIdInventoriesIndexRoute
  '/stores/$storeId/stocks/': typeof AuthenticatedStoresStoreIdStocksIndexRoute
  '/development/real-estate/kanban/$cardId/admin-authorizations': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute
  '/development/real-estate/kanban/$cardId/analytics': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute
  '/development/real-estate/kanban/$cardId/documents': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute
  '/development/real-estate/kanban/$cardId/general': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute
  '/development/real-estate/kanban/$cardId/land-commitment': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute
  '/development/real-estate/kanban/$cardId/works': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute
  '/stores/$storeId/stocks/product/$productId': typeof AuthenticatedStoresStoreIdStocksProductProductIdRoute
  '/development/real-estate/kanban/$cardId/': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/inventories': typeof AuthenticatedInventoriesRouteRouteWithChildren
  '/accounting': typeof AuthenticatedAccountingRoute
  '/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/carts': typeof AuthenticatedCartsRoute
  '/carts-control': typeof AuthenticatedCartsControlRoute
  '/cpi-inventory': typeof AuthenticatedCpiInventoryRoute
  '/industrial-configurator': typeof AuthenticatedIndustrialConfiguratorRoute
  '/staging-tools': typeof AuthenticatedStagingToolsRoute
  '/store-app-preview': typeof AuthenticatedStoreAppPreviewRoute
  '/today': typeof AuthenticatedTodayRoute
  '/planning': typeof NosidebarPlanningRoute
  '/administration/access': typeof AuthenticatedAdministrationAccessRoute
  '/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/cameras/new': typeof AuthenticatedCamerasNewRoute
  '/categories/brands': typeof AuthenticatedCategoriesBrandsRoute
  '/categories/categories': typeof AuthenticatedCategoriesCategoriesRoute
  '/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/development/map-compare': typeof AuthenticatedDevelopmentMapCompareRoute
  '/hr/collaborators': typeof AuthenticatedHrCollaboratorsRoute
  '/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/inventories/$storeId': typeof AuthenticatedInventoriesStoreIdRoute
  '/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/products/import': typeof AuthenticatedProductsImportRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/quality/articles': typeof AuthenticatedQualityArticlesRoute
  '/quality/lots': typeof AuthenticatedQualityLotsRoute
  '/sellers/establishments': typeof AuthenticatedSellersEstablishmentsRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/sellers/sellers': typeof AuthenticatedSellersSellersRoute
  '/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/stores/new': typeof AuthenticatedStoresNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/app': typeof AuthenticatedUsersAppRoute
  '/users/bo': typeof AuthenticatedUsersBoRoute
  '/users/payment-defaults': typeof AuthenticatedUsersPaymentDefaultsRoute
  '/users/payment-links': typeof AuthenticatedUsersPaymentLinksRoute
  '/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/visio-reviews/boutique': typeof AuthenticatedVisioReviewsBoutiqueRoute
  '/visio-reviews/evaluation': typeof AuthenticatedVisioReviewsEvaluationRoute
  '/visio-reviews/global': typeof AuthenticatedVisioReviewsGlobalRoute
  '/visio-reviews/operateur': typeof AuthenticatedVisioReviewsOperateurRoute
  '/visio-reviews/veille': typeof AuthenticatedVisioReviewsVeilleRoute
  '/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/cameras-views': typeof AuthenticatedCamerasViewsIndexRoute
  '/cameras': typeof AuthenticatedCamerasIndexRoute
  '/categories': typeof AuthenticatedCategoriesIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/controle-rupture': typeof AuthenticatedControleRuptureIndexRoute
  '/correction-ruptures': typeof AuthenticatedCorrectionRupturesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/logistics': typeof AuthenticatedLogisticsIndexRoute
  '/mailing-lists': typeof AuthenticatedMailingListsIndexRoute
  '/network-dashboard': typeof AuthenticatedNetworkDashboardIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/platform-stocks': typeof AuthenticatedPlatformStocksIndexRoute
  '/pre-authorizations': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/previsions-categories': typeof AuthenticatedPrevisionsCategoriesIndexRoute
  '/previsions-long-terme': typeof AuthenticatedPrevisionsLongTermeIndexRoute
  '/previsions-produits': typeof AuthenticatedPrevisionsProduitsIndexRoute
  '/previsions-semaine': typeof AuthenticatedPrevisionsSemaineIndexRoute
  '/previsions': typeof AuthenticatedPrevisionsIndexRoute
  '/product-management': typeof AuthenticatedProductManagementIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/promo-campaign': typeof AuthenticatedPromoCampaignIndexRoute
  '/quality': typeof AuthenticatedQualityIndexRoute
  '/sandbox-previsions': typeof AuthenticatedSandboxPrevisionsIndexRoute
  '/sellers': typeof AuthenticatedSellersIndexRoute
  '/sensors': typeof AuthenticatedSensorsIndexRoute
  '/service-client': typeof AuthenticatedServiceClientIndexRoute
  '/store-app-todo': typeof AuthenticatedStoreAppTodoIndexRoute
  '/stores': typeof AuthenticatedStoresIndexRoute
  '/supply': typeof AuthenticatedSupplyIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/vacances-scolaires': typeof AuthenticatedVacancesScolairesIndexRoute
  '/visio-reviews': typeof AuthenticatedVisioReviewsIndexRoute
  '/administration/admins/new': typeof AuthenticatedAdministrationAdminsNewRoute
  '/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/categories/$categoryId/edit': typeof AuthenticatedCategoriesCategoryIdEditRoute
  '/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/categories/reappro/forecast-pilot': typeof AuthenticatedCategoriesReapproForecastPilotRoute
  '/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/development/real-estate/calendar': typeof AuthenticatedDevelopmentRealEstateCalendarRoute
  '/development/real-estate/cartes-validees': typeof AuthenticatedDevelopmentRealEstateCartesValideesRoute
  '/development/real-estate/contacts': typeof AuthenticatedDevelopmentRealEstateContactsRoute
  '/development/real-estate/interest-zones': typeof AuthenticatedDevelopmentRealEstateInterestZonesRoute
  '/development/real-estate/kanban': typeof AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren
  '/development/real-estate/map': typeof AuthenticatedDevelopmentRealEstateMapRoute
  '/development/real-estate/tasks': typeof AuthenticatedDevelopmentRealEstateTasksRoute
  '/hr/planning/absence-calendar': typeof AuthenticatedHrPlanningAbsenceCalendarRoute
  '/hr/planning/attendance': typeof AuthenticatedHrPlanningAttendanceRoute
  '/hr/planning/calendar': typeof AuthenticatedHrPlanningCalendarRoute
  '/hr/planning/collaborators': typeof AuthenticatedHrPlanningCollaboratorsRouteWithChildren
  '/hr/planning/dashboard': typeof AuthenticatedHrPlanningDashboardRoute
  '/logistics/collaborators/$collaboratorId': typeof AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute
  '/logistics/collaborators/new': typeof AuthenticatedLogisticsCollaboratorsNewRoute
  '/logistics/hubs/$hubId': typeof AuthenticatedLogisticsHubsHubIdRoute
  '/logistics/hubs/new': typeof AuthenticatedLogisticsHubsNewRoute
  '/logistics/simulations/$simulationId': typeof AuthenticatedLogisticsSimulationsSimulationIdRoute
  '/logistics/vehicles/$vehicleId': typeof AuthenticatedLogisticsVehiclesVehicleIdRoute
  '/logistics/vehicles/new': typeof AuthenticatedLogisticsVehiclesNewRoute
  '/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/service-client/tickets/$id': typeof AuthenticatedServiceClientTicketsIdRoute
  '/stores/$storeId/details': typeof AuthenticatedStoresStoreIdDetailsRoute
  '/stores/$storeId/hours': typeof AuthenticatedStoresStoreIdHoursRoute
  '/stores/$storeId/inventory': typeof AuthenticatedStoresStoreIdInventoryRoute
  '/stores/$storeId/kiosks': typeof AuthenticatedStoresStoreIdKiosksRoute
  '/stores/$storeId/stats': typeof AuthenticatedStoresStoreIdStatsRoute
  '/users/edit/$userId': typeof AuthenticatedUsersEditUserIdRoute
  '/administration/roles': typeof AuthenticatedAdministrationRolesIndexRoute
  '/categories/internal': typeof AuthenticatedCategoriesInternalIndexRoute
  '/categories/reappro': typeof AuthenticatedCategoriesReapproIndexRoute
  '/development/real-estate': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/hr/planning': typeof AuthenticatedHrPlanningIndexRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdIndexRoute
  '/stores/$storeId': typeof AuthenticatedStoresStoreIdIndexRoute
  '/administration/admins/$id/edit': typeof AuthenticatedAdministrationAdminsIdEditRoute
  '/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/categories/brand/$brandId/edit': typeof AuthenticatedCategoriesBrandBrandIdEditRoute
  '/categories/reappro/forecast-pilot/daily-review': typeof AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute
  '/hr/planning/collaborators/$collaboratorId': typeof AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute
  '/sellers/establishment/$establishmentId/edit': typeof AuthenticatedSellersEstablishmentEstablishmentIdEditRoute
  '/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/administration/roles/$roleId': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
  '/stores/$storeId/inventories': typeof AuthenticatedStoresStoreIdInventoriesIndexRoute
  '/stores/$storeId/stocks': typeof AuthenticatedStoresStoreIdStocksIndexRoute
  '/development/real-estate/kanban/$cardId/admin-authorizations': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute
  '/development/real-estate/kanban/$cardId/analytics': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute
  '/development/real-estate/kanban/$cardId/documents': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute
  '/development/real-estate/kanban/$cardId/general': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute
  '/development/real-estate/kanban/$cardId/land-commitment': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute
  '/development/real-estate/kanban/$cardId/works': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute
  '/stores/$storeId/stocks/product/$productId': typeof AuthenticatedStoresStoreIdStocksProductProductIdRoute
  '/development/real-estate/kanban/$cardId': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/cameras': typeof AuthenticatedCamerasRouteRouteWithChildren
  '/_authenticated/inventories': typeof AuthenticatedInventoriesRouteRouteWithChildren
  '/_authenticated/accounting': typeof AuthenticatedAccountingRoute
  '/_authenticated/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/_authenticated/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/_authenticated/carts': typeof AuthenticatedCartsRoute
  '/_authenticated/carts-control': typeof AuthenticatedCartsControlRoute
  '/_authenticated/cpi-inventory': typeof AuthenticatedCpiInventoryRoute
  '/_authenticated/industrial-configurator': typeof AuthenticatedIndustrialConfiguratorRoute
  '/_authenticated/staging-tools': typeof AuthenticatedStagingToolsRoute
  '/_authenticated/store-app-preview': typeof AuthenticatedStoreAppPreviewRoute
  '/_authenticated/today': typeof AuthenticatedTodayRoute
  '/_nosidebar/planning': typeof NosidebarPlanningRoute
  '/_authenticated/administration/access': typeof AuthenticatedAdministrationAccessRoute
  '/_authenticated/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/_authenticated/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/_authenticated/cameras/new': typeof AuthenticatedCamerasNewRoute
  '/_authenticated/categories/brands': typeof AuthenticatedCategoriesBrandsRoute
  '/_authenticated/categories/categories': typeof AuthenticatedCategoriesCategoriesRoute
  '/_authenticated/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/_authenticated/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/_authenticated/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/_authenticated/development/map-compare': typeof AuthenticatedDevelopmentMapCompareRoute
  '/_authenticated/development/real-estate': typeof AuthenticatedDevelopmentRealEstateRouteWithChildren
  '/_authenticated/hr/collaborators': typeof AuthenticatedHrCollaboratorsRoute
  '/_authenticated/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/_authenticated/hr/planning': typeof AuthenticatedHrPlanningRouteWithChildren
  '/_authenticated/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/_authenticated/inventories/$storeId': typeof AuthenticatedInventoriesStoreIdRoute
  '/_authenticated/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/_authenticated/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/_authenticated/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/_authenticated/products/import': typeof AuthenticatedProductsImportRoute
  '/_authenticated/products/new': typeof AuthenticatedProductsNewRoute
  '/_authenticated/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/_authenticated/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/_authenticated/quality/articles': typeof AuthenticatedQualityArticlesRoute
  '/_authenticated/quality/lots': typeof AuthenticatedQualityLotsRoute
  '/_authenticated/sellers/establishments': typeof AuthenticatedSellersEstablishmentsRoute
  '/_authenticated/sellers/new': typeof AuthenticatedSellersNewRoute
  '/_authenticated/sellers/sellers': typeof AuthenticatedSellersSellersRoute
  '/_authenticated/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/_authenticated/stores/new': typeof AuthenticatedStoresNewRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/users/app': typeof AuthenticatedUsersAppRoute
  '/_authenticated/users/bo': typeof AuthenticatedUsersBoRoute
  '/_authenticated/users/payment-defaults': typeof AuthenticatedUsersPaymentDefaultsRoute
  '/_authenticated/users/payment-links': typeof AuthenticatedUsersPaymentLinksRoute
  '/_authenticated/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/_authenticated/visio-reviews/boutique': typeof AuthenticatedVisioReviewsBoutiqueRoute
  '/_authenticated/visio-reviews/evaluation': typeof AuthenticatedVisioReviewsEvaluationRoute
  '/_authenticated/visio-reviews/global': typeof AuthenticatedVisioReviewsGlobalRoute
  '/_authenticated/visio-reviews/operateur': typeof AuthenticatedVisioReviewsOperateurRoute
  '/_authenticated/visio-reviews/veille': typeof AuthenticatedVisioReviewsVeilleRoute
  '/_nosidebar/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/_authenticated/cameras-views/': typeof AuthenticatedCamerasViewsIndexRoute
  '/_authenticated/cameras/': typeof AuthenticatedCamerasIndexRoute
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/controle-rupture/': typeof AuthenticatedControleRuptureIndexRoute
  '/_authenticated/correction-ruptures/': typeof AuthenticatedCorrectionRupturesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/logistics/': typeof AuthenticatedLogisticsIndexRoute
  '/_authenticated/mailing-lists/': typeof AuthenticatedMailingListsIndexRoute
  '/_authenticated/network-dashboard/': typeof AuthenticatedNetworkDashboardIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/platform-stocks/': typeof AuthenticatedPlatformStocksIndexRoute
  '/_authenticated/pre-authorizations/': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/_authenticated/previsions-categories/': typeof AuthenticatedPrevisionsCategoriesIndexRoute
  '/_authenticated/previsions-long-terme/': typeof AuthenticatedPrevisionsLongTermeIndexRoute
  '/_authenticated/previsions-produits/': typeof AuthenticatedPrevisionsProduitsIndexRoute
  '/_authenticated/previsions-semaine/': typeof AuthenticatedPrevisionsSemaineIndexRoute
  '/_authenticated/previsions/': typeof AuthenticatedPrevisionsIndexRoute
  '/_authenticated/product-management/': typeof AuthenticatedProductManagementIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/promo-campaign/': typeof AuthenticatedPromoCampaignIndexRoute
  '/_authenticated/quality/': typeof AuthenticatedQualityIndexRoute
  '/_authenticated/sandbox-previsions/': typeof AuthenticatedSandboxPrevisionsIndexRoute
  '/_authenticated/sellers/': typeof AuthenticatedSellersIndexRoute
  '/_authenticated/sensors/': typeof AuthenticatedSensorsIndexRoute
  '/_authenticated/service-client/': typeof AuthenticatedServiceClientIndexRoute
  '/_authenticated/store-app-todo/': typeof AuthenticatedStoreAppTodoIndexRoute
  '/_authenticated/stores/': typeof AuthenticatedStoresIndexRoute
  '/_authenticated/supply/': typeof AuthenticatedSupplyIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/vacances-scolaires/': typeof AuthenticatedVacancesScolairesIndexRoute
  '/_authenticated/visio-reviews/': typeof AuthenticatedVisioReviewsIndexRoute
  '/_authenticated/administration/admins/new': typeof AuthenticatedAdministrationAdminsNewRoute
  '/_authenticated/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/_authenticated/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/_authenticated/categories/$categoryId/edit': typeof AuthenticatedCategoriesCategoryIdEditRoute
  '/_authenticated/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/_authenticated/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/_authenticated/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/_authenticated/categories/reappro/forecast-pilot': typeof AuthenticatedCategoriesReapproForecastPilotRoute
  '/_authenticated/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/_authenticated/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/_authenticated/development/real-estate/calendar': typeof AuthenticatedDevelopmentRealEstateCalendarRoute
  '/_authenticated/development/real-estate/cartes-validees': typeof AuthenticatedDevelopmentRealEstateCartesValideesRoute
  '/_authenticated/development/real-estate/contacts': typeof AuthenticatedDevelopmentRealEstateContactsRoute
  '/_authenticated/development/real-estate/interest-zones': typeof AuthenticatedDevelopmentRealEstateInterestZonesRoute
  '/_authenticated/development/real-estate/kanban': typeof AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren
  '/_authenticated/development/real-estate/map': typeof AuthenticatedDevelopmentRealEstateMapRoute
  '/_authenticated/development/real-estate/tasks': typeof AuthenticatedDevelopmentRealEstateTasksRoute
  '/_authenticated/hr/planning/absence-calendar': typeof AuthenticatedHrPlanningAbsenceCalendarRoute
  '/_authenticated/hr/planning/attendance': typeof AuthenticatedHrPlanningAttendanceRoute
  '/_authenticated/hr/planning/calendar': typeof AuthenticatedHrPlanningCalendarRoute
  '/_authenticated/hr/planning/collaborators': typeof AuthenticatedHrPlanningCollaboratorsRouteWithChildren
  '/_authenticated/hr/planning/dashboard': typeof AuthenticatedHrPlanningDashboardRoute
  '/_authenticated/logistics/collaborators/$collaboratorId': typeof AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute
  '/_authenticated/logistics/collaborators/new': typeof AuthenticatedLogisticsCollaboratorsNewRoute
  '/_authenticated/logistics/hubs/$hubId': typeof AuthenticatedLogisticsHubsHubIdRoute
  '/_authenticated/logistics/hubs/new': typeof AuthenticatedLogisticsHubsNewRoute
  '/_authenticated/logistics/simulations/$simulationId': typeof AuthenticatedLogisticsSimulationsSimulationIdRoute
  '/_authenticated/logistics/vehicles/$vehicleId': typeof AuthenticatedLogisticsVehiclesVehicleIdRoute
  '/_authenticated/logistics/vehicles/new': typeof AuthenticatedLogisticsVehiclesNewRoute
  '/_authenticated/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/_authenticated/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/_authenticated/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/_authenticated/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/_authenticated/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/_authenticated/service-client/tickets/$id': typeof AuthenticatedServiceClientTicketsIdRoute
  '/_authenticated/stores/$storeId/details': typeof AuthenticatedStoresStoreIdDetailsRoute
  '/_authenticated/stores/$storeId/hours': typeof AuthenticatedStoresStoreIdHoursRoute
  '/_authenticated/stores/$storeId/inventory': typeof AuthenticatedStoresStoreIdInventoryRoute
  '/_authenticated/stores/$storeId/kiosks': typeof AuthenticatedStoresStoreIdKiosksRoute
  '/_authenticated/stores/$storeId/stats': typeof AuthenticatedStoresStoreIdStatsRoute
  '/_authenticated/users/edit/$userId': typeof AuthenticatedUsersEditUserIdRoute
  '/_authenticated/administration/roles/': typeof AuthenticatedAdministrationRolesIndexRoute
  '/_authenticated/categories/internal/': typeof AuthenticatedCategoriesInternalIndexRoute
  '/_authenticated/categories/reappro/': typeof AuthenticatedCategoriesReapproIndexRoute
  '/_authenticated/development/real-estate/': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/_authenticated/hr/planning/': typeof AuthenticatedHrPlanningIndexRoute
  '/_authenticated/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/_authenticated/stores/$storeId/': typeof AuthenticatedStoresStoreIdIndexRoute
  '/_authenticated/administration/admins/$id/edit': typeof AuthenticatedAdministrationAdminsIdEditRoute
  '/_authenticated/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/_authenticated/categories/brand/$brandId/edit': typeof AuthenticatedCategoriesBrandBrandIdEditRoute
  '/_authenticated/categories/reappro/forecast-pilot_/daily-review': typeof AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute
  '/_authenticated/development/real-estate/kanban/$cardId': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRouteWithChildren
  '/_authenticated/hr/planning/collaborators/$collaboratorId': typeof AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute
  '/_authenticated/sellers/establishment/$establishmentId/edit': typeof AuthenticatedSellersEstablishmentEstablishmentIdEditRoute
  '/_authenticated/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/_authenticated/administration/roles/$roleId/': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
  '/_authenticated/stores/$storeId/inventories/': typeof AuthenticatedStoresStoreIdInventoriesIndexRoute
  '/_authenticated/stores/$storeId/stocks/': typeof AuthenticatedStoresStoreIdStocksIndexRoute
  '/_authenticated/development/real-estate/kanban/$cardId/admin-authorizations': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute
  '/_authenticated/development/real-estate/kanban/$cardId/analytics': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute
  '/_authenticated/development/real-estate/kanban/$cardId/documents': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute
  '/_authenticated/development/real-estate/kanban/$cardId/general': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute
  '/_authenticated/development/real-estate/kanban/$cardId/land-commitment': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute
  '/_authenticated/development/real-estate/kanban/$cardId/works': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute
  '/_authenticated/stores/$storeId/stocks/product/$productId': typeof AuthenticatedStoresStoreIdStocksProductProductIdRoute
  '/_authenticated/development/real-estate/kanban/$cardId/': typeof AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/cameras'
    | '/inventories'
    | '/accounting'
    | '/cart-photos-x7k2qz'
    | '/cart-vision-checks'
    | '/carts'
    | '/carts-control'
    | '/cpi-inventory'
    | '/industrial-configurator'
    | '/staging-tools'
    | '/store-app-preview'
    | '/today'
    | '/planning'
    | '/administration/access'
    | '/cameras-views/new'
    | '/cameras/config'
    | '/cameras/new'
    | '/categories/brands'
    | '/categories/categories'
    | '/categories/new'
    | '/companies/new'
    | '/dashboard/hours'
    | '/development/map-compare'
    | '/development/real-estate'
    | '/hr/collaborators'
    | '/hr/interim-agencies'
    | '/hr/planning'
    | '/hr/sms-tracking'
    | '/inventories/$storeId'
    | '/mailing-lists/$key'
    | '/notifications/$id'
    | '/notifications/new'
    | '/products/import'
    | '/products/new'
    | '/promo-campaign/new'
    | '/quality/$lot'
    | '/quality/articles'
    | '/quality/lots'
    | '/sellers/establishments'
    | '/sellers/new'
    | '/sellers/sellers'
    | '/sensors/new'
    | '/stores/new'
    | '/users/$userId'
    | '/users/app'
    | '/users/bo'
    | '/users/payment-defaults'
    | '/users/payment-links'
    | '/visio-reviews/admin'
    | '/visio-reviews/boutique'
    | '/visio-reviews/evaluation'
    | '/visio-reviews/global'
    | '/visio-reviews/operateur'
    | '/visio-reviews/veille'
    | '/workshift-attendance/$storeId'
    | '/cameras-views/'
    | '/cameras/'
    | '/categories/'
    | '/companies/'
    | '/controle-rupture/'
    | '/correction-ruptures/'
    | '/dashboard/'
    | '/logistics/'
    | '/mailing-lists/'
    | '/network-dashboard/'
    | '/notifications/'
    | '/platform-stocks/'
    | '/pre-authorizations/'
    | '/previsions-categories/'
    | '/previsions-long-terme/'
    | '/previsions-produits/'
    | '/previsions-semaine/'
    | '/previsions/'
    | '/product-management/'
    | '/products/'
    | '/promo-campaign/'
    | '/quality/'
    | '/sandbox-previsions/'
    | '/sellers/'
    | '/sensors/'
    | '/service-client/'
    | '/store-app-todo/'
    | '/stores/'
    | '/supply/'
    | '/users/'
    | '/vacances-scolaires/'
    | '/visio-reviews/'
    | '/administration/admins/new'
    | '/administration/roles/new'
    | '/cameras-views/$viewId/edit'
    | '/categories/$categoryId/edit'
    | '/categories/brand/new'
    | '/categories/internal/new'
    | '/categories/reappro/config'
    | '/categories/reappro/forecast-pilot'
    | '/categories/reappro/new'
    | '/companies/$id/edit'
    | '/development/real-estate/calendar'
    | '/development/real-estate/cartes-validees'
    | '/development/real-estate/contacts'
    | '/development/real-estate/interest-zones'
    | '/development/real-estate/kanban'
    | '/development/real-estate/map'
    | '/development/real-estate/tasks'
    | '/hr/planning/absence-calendar'
    | '/hr/planning/attendance'
    | '/hr/planning/calendar'
    | '/hr/planning/collaborators'
    | '/hr/planning/dashboard'
    | '/logistics/collaborators/$collaboratorId'
    | '/logistics/collaborators/new'
    | '/logistics/hubs/$hubId'
    | '/logistics/hubs/new'
    | '/logistics/simulations/$simulationId'
    | '/logistics/vehicles/$vehicleId'
    | '/logistics/vehicles/new'
    | '/pre-authorizations/$sessionId/recordings'
    | '/products/$productId/edit'
    | '/sellers/$sellerId/edit'
    | '/sellers/establishment/new'
    | '/sensors/fridge/new'
    | '/service-client/tickets/$id'
    | '/stores/$storeId/details'
    | '/stores/$storeId/hours'
    | '/stores/$storeId/inventory'
    | '/stores/$storeId/kiosks'
    | '/stores/$storeId/stats'
    | '/users/edit/$userId'
    | '/administration/roles/'
    | '/categories/internal/'
    | '/categories/reappro/'
    | '/development/real-estate/'
    | '/hr/planning/'
    | '/products/$productId/'
    | '/stores/$storeId/'
    | '/administration/admins/$id/edit'
    | '/administration/roles/$roleId/edit'
    | '/categories/brand/$brandId/edit'
    | '/categories/reappro/forecast-pilot/daily-review'
    | '/development/real-estate/kanban/$cardId'
    | '/hr/planning/collaborators/$collaboratorId'
    | '/sellers/establishment/$establishmentId/edit'
    | '/stores/$storeId/inventories/$inventoryId'
    | '/administration/roles/$roleId/'
    | '/stores/$storeId/inventories/'
    | '/stores/$storeId/stocks/'
    | '/development/real-estate/kanban/$cardId/admin-authorizations'
    | '/development/real-estate/kanban/$cardId/analytics'
    | '/development/real-estate/kanban/$cardId/documents'
    | '/development/real-estate/kanban/$cardId/general'
    | '/development/real-estate/kanban/$cardId/land-commitment'
    | '/development/real-estate/kanban/$cardId/works'
    | '/stores/$storeId/stocks/product/$productId'
    | '/development/real-estate/kanban/$cardId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/inventories'
    | '/accounting'
    | '/cart-photos-x7k2qz'
    | '/cart-vision-checks'
    | '/carts'
    | '/carts-control'
    | '/cpi-inventory'
    | '/industrial-configurator'
    | '/staging-tools'
    | '/store-app-preview'
    | '/today'
    | '/planning'
    | '/administration/access'
    | '/cameras-views/new'
    | '/cameras/config'
    | '/cameras/new'
    | '/categories/brands'
    | '/categories/categories'
    | '/categories/new'
    | '/companies/new'
    | '/dashboard/hours'
    | '/development/map-compare'
    | '/hr/collaborators'
    | '/hr/interim-agencies'
    | '/hr/sms-tracking'
    | '/inventories/$storeId'
    | '/mailing-lists/$key'
    | '/notifications/$id'
    | '/notifications/new'
    | '/products/import'
    | '/products/new'
    | '/promo-campaign/new'
    | '/quality/$lot'
    | '/quality/articles'
    | '/quality/lots'
    | '/sellers/establishments'
    | '/sellers/new'
    | '/sellers/sellers'
    | '/sensors/new'
    | '/stores/new'
    | '/users/$userId'
    | '/users/app'
    | '/users/bo'
    | '/users/payment-defaults'
    | '/users/payment-links'
    | '/visio-reviews/admin'
    | '/visio-reviews/boutique'
    | '/visio-reviews/evaluation'
    | '/visio-reviews/global'
    | '/visio-reviews/operateur'
    | '/visio-reviews/veille'
    | '/workshift-attendance/$storeId'
    | '/cameras-views'
    | '/cameras'
    | '/categories'
    | '/companies'
    | '/controle-rupture'
    | '/correction-ruptures'
    | '/dashboard'
    | '/logistics'
    | '/mailing-lists'
    | '/network-dashboard'
    | '/notifications'
    | '/platform-stocks'
    | '/pre-authorizations'
    | '/previsions-categories'
    | '/previsions-long-terme'
    | '/previsions-produits'
    | '/previsions-semaine'
    | '/previsions'
    | '/product-management'
    | '/products'
    | '/promo-campaign'
    | '/quality'
    | '/sandbox-previsions'
    | '/sellers'
    | '/sensors'
    | '/service-client'
    | '/store-app-todo'
    | '/stores'
    | '/supply'
    | '/users'
    | '/vacances-scolaires'
    | '/visio-reviews'
    | '/administration/admins/new'
    | '/administration/roles/new'
    | '/cameras-views/$viewId/edit'
    | '/categories/$categoryId/edit'
    | '/categories/brand/new'
    | '/categories/internal/new'
    | '/categories/reappro/config'
    | '/categories/reappro/forecast-pilot'
    | '/categories/reappro/new'
    | '/companies/$id/edit'
    | '/development/real-estate/calendar'
    | '/development/real-estate/cartes-validees'
    | '/development/real-estate/contacts'
    | '/development/real-estate/interest-zones'
    | '/development/real-estate/kanban'
    | '/development/real-estate/map'
    | '/development/real-estate/tasks'
    | '/hr/planning/absence-calendar'
    | '/hr/planning/attendance'
    | '/hr/planning/calendar'
    | '/hr/planning/collaborators'
    | '/hr/planning/dashboard'
    | '/logistics/collaborators/$collaboratorId'
    | '/logistics/collaborators/new'
    | '/logistics/hubs/$hubId'
    | '/logistics/hubs/new'
    | '/logistics/simulations/$simulationId'
    | '/logistics/vehicles/$vehicleId'
    | '/logistics/vehicles/new'
    | '/pre-authorizations/$sessionId/recordings'
    | '/products/$productId/edit'
    | '/sellers/$sellerId/edit'
    | '/sellers/establishment/new'
    | '/sensors/fridge/new'
    | '/service-client/tickets/$id'
    | '/stores/$storeId/details'
    | '/stores/$storeId/hours'
    | '/stores/$storeId/inventory'
    | '/stores/$storeId/kiosks'
    | '/stores/$storeId/stats'
    | '/users/edit/$userId'
    | '/administration/roles'
    | '/categories/internal'
    | '/categories/reappro'
    | '/development/real-estate'
    | '/hr/planning'
    | '/products/$productId'
    | '/stores/$storeId'
    | '/administration/admins/$id/edit'
    | '/administration/roles/$roleId/edit'
    | '/categories/brand/$brandId/edit'
    | '/categories/reappro/forecast-pilot/daily-review'
    | '/hr/planning/collaborators/$collaboratorId'
    | '/sellers/establishment/$establishmentId/edit'
    | '/stores/$storeId/inventories/$inventoryId'
    | '/administration/roles/$roleId'
    | '/stores/$storeId/inventories'
    | '/stores/$storeId/stocks'
    | '/development/real-estate/kanban/$cardId/admin-authorizations'
    | '/development/real-estate/kanban/$cardId/analytics'
    | '/development/real-estate/kanban/$cardId/documents'
    | '/development/real-estate/kanban/$cardId/general'
    | '/development/real-estate/kanban/$cardId/land-commitment'
    | '/development/real-estate/kanban/$cardId/works'
    | '/stores/$storeId/stocks/product/$productId'
    | '/development/real-estate/kanban/$cardId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/cameras'
    | '/_authenticated/inventories'
    | '/_authenticated/accounting'
    | '/_authenticated/cart-photos-x7k2qz'
    | '/_authenticated/cart-vision-checks'
    | '/_authenticated/carts'
    | '/_authenticated/carts-control'
    | '/_authenticated/cpi-inventory'
    | '/_authenticated/industrial-configurator'
    | '/_authenticated/staging-tools'
    | '/_authenticated/store-app-preview'
    | '/_authenticated/today'
    | '/_nosidebar/planning'
    | '/_authenticated/administration/access'
    | '/_authenticated/cameras-views/new'
    | '/_authenticated/cameras/config'
    | '/_authenticated/cameras/new'
    | '/_authenticated/categories/brands'
    | '/_authenticated/categories/categories'
    | '/_authenticated/categories/new'
    | '/_authenticated/companies/new'
    | '/_authenticated/dashboard/hours'
    | '/_authenticated/development/map-compare'
    | '/_authenticated/development/real-estate'
    | '/_authenticated/hr/collaborators'
    | '/_authenticated/hr/interim-agencies'
    | '/_authenticated/hr/planning'
    | '/_authenticated/hr/sms-tracking'
    | '/_authenticated/inventories/$storeId'
    | '/_authenticated/mailing-lists/$key'
    | '/_authenticated/notifications/$id'
    | '/_authenticated/notifications/new'
    | '/_authenticated/products/import'
    | '/_authenticated/products/new'
    | '/_authenticated/promo-campaign/new'
    | '/_authenticated/quality/$lot'
    | '/_authenticated/quality/articles'
    | '/_authenticated/quality/lots'
    | '/_authenticated/sellers/establishments'
    | '/_authenticated/sellers/new'
    | '/_authenticated/sellers/sellers'
    | '/_authenticated/sensors/new'
    | '/_authenticated/stores/new'
    | '/_authenticated/users/$userId'
    | '/_authenticated/users/app'
    | '/_authenticated/users/bo'
    | '/_authenticated/users/payment-defaults'
    | '/_authenticated/users/payment-links'
    | '/_authenticated/visio-reviews/admin'
    | '/_authenticated/visio-reviews/boutique'
    | '/_authenticated/visio-reviews/evaluation'
    | '/_authenticated/visio-reviews/global'
    | '/_authenticated/visio-reviews/operateur'
    | '/_authenticated/visio-reviews/veille'
    | '/_nosidebar/workshift-attendance/$storeId'
    | '/_authenticated/cameras-views/'
    | '/_authenticated/cameras/'
    | '/_authenticated/categories/'
    | '/_authenticated/companies/'
    | '/_authenticated/controle-rupture/'
    | '/_authenticated/correction-ruptures/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/logistics/'
    | '/_authenticated/mailing-lists/'
    | '/_authenticated/network-dashboard/'
    | '/_authenticated/notifications/'
    | '/_authenticated/platform-stocks/'
    | '/_authenticated/pre-authorizations/'
    | '/_authenticated/previsions-categories/'
    | '/_authenticated/previsions-long-terme/'
    | '/_authenticated/previsions-produits/'
    | '/_authenticated/previsions-semaine/'
    | '/_authenticated/previsions/'
    | '/_authenticated/product-management/'
    | '/_authenticated/products/'
    | '/_authenticated/promo-campaign/'
    | '/_authenticated/quality/'
    | '/_authenticated/sandbox-previsions/'
    | '/_authenticated/sellers/'
    | '/_authenticated/sensors/'
    | '/_authenticated/service-client/'
    | '/_authenticated/store-app-todo/'
    | '/_authenticated/stores/'
    | '/_authenticated/supply/'
    | '/_authenticated/users/'
    | '/_authenticated/vacances-scolaires/'
    | '/_authenticated/visio-reviews/'
    | '/_authenticated/administration/admins/new'
    | '/_authenticated/administration/roles/new'
    | '/_authenticated/cameras-views/$viewId/edit'
    | '/_authenticated/categories/$categoryId/edit'
    | '/_authenticated/categories/brand/new'
    | '/_authenticated/categories/internal/new'
    | '/_authenticated/categories/reappro/config'
    | '/_authenticated/categories/reappro/forecast-pilot'
    | '/_authenticated/categories/reappro/new'
    | '/_authenticated/companies/$id/edit'
    | '/_authenticated/development/real-estate/calendar'
    | '/_authenticated/development/real-estate/cartes-validees'
    | '/_authenticated/development/real-estate/contacts'
    | '/_authenticated/development/real-estate/interest-zones'
    | '/_authenticated/development/real-estate/kanban'
    | '/_authenticated/development/real-estate/map'
    | '/_authenticated/development/real-estate/tasks'
    | '/_authenticated/hr/planning/absence-calendar'
    | '/_authenticated/hr/planning/attendance'
    | '/_authenticated/hr/planning/calendar'
    | '/_authenticated/hr/planning/collaborators'
    | '/_authenticated/hr/planning/dashboard'
    | '/_authenticated/logistics/collaborators/$collaboratorId'
    | '/_authenticated/logistics/collaborators/new'
    | '/_authenticated/logistics/hubs/$hubId'
    | '/_authenticated/logistics/hubs/new'
    | '/_authenticated/logistics/simulations/$simulationId'
    | '/_authenticated/logistics/vehicles/$vehicleId'
    | '/_authenticated/logistics/vehicles/new'
    | '/_authenticated/pre-authorizations/$sessionId/recordings'
    | '/_authenticated/products/$productId/edit'
    | '/_authenticated/sellers/$sellerId/edit'
    | '/_authenticated/sellers/establishment/new'
    | '/_authenticated/sensors/fridge/new'
    | '/_authenticated/service-client/tickets/$id'
    | '/_authenticated/stores/$storeId/details'
    | '/_authenticated/stores/$storeId/hours'
    | '/_authenticated/stores/$storeId/inventory'
    | '/_authenticated/stores/$storeId/kiosks'
    | '/_authenticated/stores/$storeId/stats'
    | '/_authenticated/users/edit/$userId'
    | '/_authenticated/administration/roles/'
    | '/_authenticated/categories/internal/'
    | '/_authenticated/categories/reappro/'
    | '/_authenticated/development/real-estate/'
    | '/_authenticated/hr/planning/'
    | '/_authenticated/products/$productId/'
    | '/_authenticated/stores/$storeId/'
    | '/_authenticated/administration/admins/$id/edit'
    | '/_authenticated/administration/roles/$roleId/edit'
    | '/_authenticated/categories/brand/$brandId/edit'
    | '/_authenticated/categories/reappro/forecast-pilot_/daily-review'
    | '/_authenticated/development/real-estate/kanban/$cardId'
    | '/_authenticated/hr/planning/collaborators/$collaboratorId'
    | '/_authenticated/sellers/establishment/$establishmentId/edit'
    | '/_authenticated/stores/$storeId/inventories/$inventoryId'
    | '/_authenticated/administration/roles/$roleId/'
    | '/_authenticated/stores/$storeId/inventories/'
    | '/_authenticated/stores/$storeId/stocks/'
    | '/_authenticated/development/real-estate/kanban/$cardId/admin-authorizations'
    | '/_authenticated/development/real-estate/kanban/$cardId/analytics'
    | '/_authenticated/development/real-estate/kanban/$cardId/documents'
    | '/_authenticated/development/real-estate/kanban/$cardId/general'
    | '/_authenticated/development/real-estate/kanban/$cardId/land-commitment'
    | '/_authenticated/development/real-estate/kanban/$cardId/works'
    | '/_authenticated/stores/$storeId/stocks/product/$productId'
    | '/_authenticated/development/real-estate/kanban/$cardId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  NosidebarPlanningRoute: typeof NosidebarPlanningRoute
  NosidebarWorkshiftAttendanceStoreIdRoute: typeof NosidebarWorkshiftAttendanceStoreIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/accounting': {
      id: '/_authenticated/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AuthenticatedAccountingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras': {
      id: '/_authenticated/cameras'
      path: '/cameras'
      fullPath: '/cameras'
      preLoaderRoute: typeof AuthenticatedCamerasRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cart-photos-x7k2qz': {
      id: '/_authenticated/cart-photos-x7k2qz'
      path: '/cart-photos-x7k2qz'
      fullPath: '/cart-photos-x7k2qz'
      preLoaderRoute: typeof AuthenticatedCartPhotosX7k2qzRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cart-vision-checks': {
      id: '/_authenticated/cart-vision-checks'
      path: '/cart-vision-checks'
      fullPath: '/cart-vision-checks'
      preLoaderRoute: typeof AuthenticatedCartVisionChecksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/carts': {
      id: '/_authenticated/carts'
      path: '/carts'
      fullPath: '/carts'
      preLoaderRoute: typeof AuthenticatedCartsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/carts-control': {
      id: '/_authenticated/carts-control'
      path: '/carts-control'
      fullPath: '/carts-control'
      preLoaderRoute: typeof AuthenticatedCartsControlRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cpi-inventory': {
      id: '/_authenticated/cpi-inventory'
      path: '/cpi-inventory'
      fullPath: '/cpi-inventory'
      preLoaderRoute: typeof AuthenticatedCpiInventoryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/industrial-configurator': {
      id: '/_authenticated/industrial-configurator'
      path: '/industrial-configurator'
      fullPath: '/industrial-configurator'
      preLoaderRoute: typeof AuthenticatedIndustrialConfiguratorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventories': {
      id: '/_authenticated/inventories'
      path: '/inventories'
      fullPath: '/inventories'
      preLoaderRoute: typeof AuthenticatedInventoriesRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/staging-tools': {
      id: '/_authenticated/staging-tools'
      path: '/staging-tools'
      fullPath: '/staging-tools'
      preLoaderRoute: typeof AuthenticatedStagingToolsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/store-app-preview': {
      id: '/_authenticated/store-app-preview'
      path: '/store-app-preview'
      fullPath: '/store-app-preview'
      preLoaderRoute: typeof AuthenticatedStoreAppPreviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/today': {
      id: '/_authenticated/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthenticatedTodayRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_nosidebar/planning': {
      id: '/_nosidebar/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof NosidebarPlanningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/administration/access': {
      id: '/_authenticated/administration/access'
      path: '/administration/access'
      fullPath: '/administration/access'
      preLoaderRoute: typeof AuthenticatedAdministrationAccessRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras-views/': {
      id: '/_authenticated/cameras-views/'
      path: '/cameras-views'
      fullPath: '/cameras-views/'
      preLoaderRoute: typeof AuthenticatedCamerasViewsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras-views/new': {
      id: '/_authenticated/cameras-views/new'
      path: '/cameras-views/new'
      fullPath: '/cameras-views/new'
      preLoaderRoute: typeof AuthenticatedCamerasViewsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras/': {
      id: '/_authenticated/cameras/'
      path: '/'
      fullPath: '/cameras/'
      preLoaderRoute: typeof AuthenticatedCamerasIndexRouteImport
      parentRoute: typeof AuthenticatedCamerasRouteRoute
    }
    '/_authenticated/cameras/config': {
      id: '/_authenticated/cameras/config'
      path: '/config'
      fullPath: '/cameras/config'
      preLoaderRoute: typeof AuthenticatedCamerasConfigRouteImport
      parentRoute: typeof AuthenticatedCamerasRouteRoute
    }
    '/_authenticated/cameras/new': {
      id: '/_authenticated/cameras/new'
      path: '/new'
      fullPath: '/cameras/new'
      preLoaderRoute: typeof AuthenticatedCamerasNewRouteImport
      parentRoute: typeof AuthenticatedCamerasRouteRoute
    }
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AuthenticatedCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/brands': {
      id: '/_authenticated/categories/brands'
      path: '/categories/brands'
      fullPath: '/categories/brands'
      preLoaderRoute: typeof AuthenticatedCategoriesBrandsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/categories': {
      id: '/_authenticated/categories/categories'
      path: '/categories/categories'
      fullPath: '/categories/categories'
      preLoaderRoute: typeof AuthenticatedCategoriesCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/new': {
      id: '/_authenticated/categories/new'
      path: '/categories/new'
      fullPath: '/categories/new'
      preLoaderRoute: typeof AuthenticatedCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/new': {
      id: '/_authenticated/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof AuthenticatedCompaniesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/controle-rupture/': {
      id: '/_authenticated/controle-rupture/'
      path: '/controle-rupture'
      fullPath: '/controle-rupture/'
      preLoaderRoute: typeof AuthenticatedControleRuptureIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/correction-ruptures/': {
      id: '/_authenticated/correction-ruptures/'
      path: '/correction-ruptures'
      fullPath: '/correction-ruptures/'
      preLoaderRoute: typeof AuthenticatedCorrectionRupturesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/hours': {
      id: '/_authenticated/dashboard/hours'
      path: '/dashboard/hours'
      fullPath: '/dashboard/hours'
      preLoaderRoute: typeof AuthenticatedDashboardHoursRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/map-compare': {
      id: '/_authenticated/development/map-compare'
      path: '/development/map-compare'
      fullPath: '/development/map-compare'
      preLoaderRoute: typeof AuthenticatedDevelopmentMapCompareRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate': {
      id: '/_authenticated/development/real-estate'
      path: '/development/real-estate'
      fullPath: '/development/real-estate'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/collaborators': {
      id: '/_authenticated/hr/collaborators'
      path: '/hr/collaborators'
      fullPath: '/hr/collaborators'
      preLoaderRoute: typeof AuthenticatedHrCollaboratorsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/interim-agencies': {
      id: '/_authenticated/hr/interim-agencies'
      path: '/hr/interim-agencies'
      fullPath: '/hr/interim-agencies'
      preLoaderRoute: typeof AuthenticatedHrInterimAgenciesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/planning': {
      id: '/_authenticated/hr/planning'
      path: '/hr/planning'
      fullPath: '/hr/planning'
      preLoaderRoute: typeof AuthenticatedHrPlanningRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/sms-tracking': {
      id: '/_authenticated/hr/sms-tracking'
      path: '/hr/sms-tracking'
      fullPath: '/hr/sms-tracking'
      preLoaderRoute: typeof AuthenticatedHrSmsTrackingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventories/$storeId': {
      id: '/_authenticated/inventories/$storeId'
      path: '/$storeId'
      fullPath: '/inventories/$storeId'
      preLoaderRoute: typeof AuthenticatedInventoriesStoreIdRouteImport
      parentRoute: typeof AuthenticatedInventoriesRouteRoute
    }
    '/_authenticated/logistics/': {
      id: '/_authenticated/logistics/'
      path: '/logistics'
      fullPath: '/logistics/'
      preLoaderRoute: typeof AuthenticatedLogisticsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/mailing-lists/': {
      id: '/_authenticated/mailing-lists/'
      path: '/mailing-lists'
      fullPath: '/mailing-lists/'
      preLoaderRoute: typeof AuthenticatedMailingListsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/mailing-lists/$key': {
      id: '/_authenticated/mailing-lists/$key'
      path: '/mailing-lists/$key'
      fullPath: '/mailing-lists/$key'
      preLoaderRoute: typeof AuthenticatedMailingListsKeyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/network-dashboard/': {
      id: '/_authenticated/network-dashboard/'
      path: '/network-dashboard'
      fullPath: '/network-dashboard/'
      preLoaderRoute: typeof AuthenticatedNetworkDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/$id': {
      id: '/_authenticated/notifications/$id'
      path: '/notifications/$id'
      fullPath: '/notifications/$id'
      preLoaderRoute: typeof AuthenticatedNotificationsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/new': {
      id: '/_authenticated/notifications/new'
      path: '/notifications/new'
      fullPath: '/notifications/new'
      preLoaderRoute: typeof AuthenticatedNotificationsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform-stocks/': {
      id: '/_authenticated/platform-stocks/'
      path: '/platform-stocks'
      fullPath: '/platform-stocks/'
      preLoaderRoute: typeof AuthenticatedPlatformStocksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pre-authorizations/': {
      id: '/_authenticated/pre-authorizations/'
      path: '/pre-authorizations'
      fullPath: '/pre-authorizations/'
      preLoaderRoute: typeof AuthenticatedPreAuthorizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/previsions-categories/': {
      id: '/_authenticated/previsions-categories/'
      path: '/previsions-categories'
      fullPath: '/previsions-categories/'
      preLoaderRoute: typeof AuthenticatedPrevisionsCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/previsions-long-terme/': {
      id: '/_authenticated/previsions-long-terme/'
      path: '/previsions-long-terme'
      fullPath: '/previsions-long-terme/'
      preLoaderRoute: typeof AuthenticatedPrevisionsLongTermeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/previsions-produits/': {
      id: '/_authenticated/previsions-produits/'
      path: '/previsions-produits'
      fullPath: '/previsions-produits/'
      preLoaderRoute: typeof AuthenticatedPrevisionsProduitsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/previsions-semaine/': {
      id: '/_authenticated/previsions-semaine/'
      path: '/previsions-semaine'
      fullPath: '/previsions-semaine/'
      preLoaderRoute: typeof AuthenticatedPrevisionsSemaineIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/previsions/': {
      id: '/_authenticated/previsions/'
      path: '/previsions'
      fullPath: '/previsions/'
      preLoaderRoute: typeof AuthenticatedPrevisionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/product-management/': {
      id: '/_authenticated/product-management/'
      path: '/product-management'
      fullPath: '/product-management/'
      preLoaderRoute: typeof AuthenticatedProductManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/import': {
      id: '/_authenticated/products/import'
      path: '/products/import'
      fullPath: '/products/import'
      preLoaderRoute: typeof AuthenticatedProductsImportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/new': {
      id: '/_authenticated/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AuthenticatedProductsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/promo-campaign/': {
      id: '/_authenticated/promo-campaign/'
      path: '/promo-campaign'
      fullPath: '/promo-campaign/'
      preLoaderRoute: typeof AuthenticatedPromoCampaignIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/promo-campaign/new': {
      id: '/_authenticated/promo-campaign/new'
      path: '/promo-campaign/new'
      fullPath: '/promo-campaign/new'
      preLoaderRoute: typeof AuthenticatedPromoCampaignNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/': {
      id: '/_authenticated/quality/'
      path: '/quality'
      fullPath: '/quality/'
      preLoaderRoute: typeof AuthenticatedQualityIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/$lot': {
      id: '/_authenticated/quality/$lot'
      path: '/quality/$lot'
      fullPath: '/quality/$lot'
      preLoaderRoute: typeof AuthenticatedQualityLotRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/articles': {
      id: '/_authenticated/quality/articles'
      path: '/quality/articles'
      fullPath: '/quality/articles'
      preLoaderRoute: typeof AuthenticatedQualityArticlesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/lots': {
      id: '/_authenticated/quality/lots'
      path: '/quality/lots'
      fullPath: '/quality/lots'
      preLoaderRoute: typeof AuthenticatedQualityLotsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sandbox-previsions/': {
      id: '/_authenticated/sandbox-previsions/'
      path: '/sandbox-previsions'
      fullPath: '/sandbox-previsions/'
      preLoaderRoute: typeof AuthenticatedSandboxPrevisionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/': {
      id: '/_authenticated/sellers/'
      path: '/sellers'
      fullPath: '/sellers/'
      preLoaderRoute: typeof AuthenticatedSellersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/establishments': {
      id: '/_authenticated/sellers/establishments'
      path: '/sellers/establishments'
      fullPath: '/sellers/establishments'
      preLoaderRoute: typeof AuthenticatedSellersEstablishmentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/new': {
      id: '/_authenticated/sellers/new'
      path: '/sellers/new'
      fullPath: '/sellers/new'
      preLoaderRoute: typeof AuthenticatedSellersNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/sellers': {
      id: '/_authenticated/sellers/sellers'
      path: '/sellers/sellers'
      fullPath: '/sellers/sellers'
      preLoaderRoute: typeof AuthenticatedSellersSellersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/': {
      id: '/_authenticated/sensors/'
      path: '/sensors'
      fullPath: '/sensors/'
      preLoaderRoute: typeof AuthenticatedSensorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/new': {
      id: '/_authenticated/sensors/new'
      path: '/sensors/new'
      fullPath: '/sensors/new'
      preLoaderRoute: typeof AuthenticatedSensorsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/service-client/': {
      id: '/_authenticated/service-client/'
      path: '/service-client'
      fullPath: '/service-client/'
      preLoaderRoute: typeof AuthenticatedServiceClientIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/store-app-todo/': {
      id: '/_authenticated/store-app-todo/'
      path: '/store-app-todo'
      fullPath: '/store-app-todo/'
      preLoaderRoute: typeof AuthenticatedStoreAppTodoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/': {
      id: '/_authenticated/stores/'
      path: '/stores'
      fullPath: '/stores/'
      preLoaderRoute: typeof AuthenticatedStoresIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/new': {
      id: '/_authenticated/stores/new'
      path: '/stores/new'
      fullPath: '/stores/new'
      preLoaderRoute: typeof AuthenticatedStoresNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supply/': {
      id: '/_authenticated/supply/'
      path: '/supply'
      fullPath: '/supply/'
      preLoaderRoute: typeof AuthenticatedSupplyIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/app': {
      id: '/_authenticated/users/app'
      path: '/users/app'
      fullPath: '/users/app'
      preLoaderRoute: typeof AuthenticatedUsersAppRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/bo': {
      id: '/_authenticated/users/bo'
      path: '/users/bo'
      fullPath: '/users/bo'
      preLoaderRoute: typeof AuthenticatedUsersBoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/payment-defaults': {
      id: '/_authenticated/users/payment-defaults'
      path: '/users/payment-defaults'
      fullPath: '/users/payment-defaults'
      preLoaderRoute: typeof AuthenticatedUsersPaymentDefaultsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/payment-links': {
      id: '/_authenticated/users/payment-links'
      path: '/users/payment-links'
      fullPath: '/users/payment-links'
      preLoaderRoute: typeof AuthenticatedUsersPaymentLinksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/vacances-scolaires/': {
      id: '/_authenticated/vacances-scolaires/'
      path: '/vacances-scolaires'
      fullPath: '/vacances-scolaires/'
      preLoaderRoute: typeof AuthenticatedVacancesScolairesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/': {
      id: '/_authenticated/visio-reviews/'
      path: '/visio-reviews'
      fullPath: '/visio-reviews/'
      preLoaderRoute: typeof AuthenticatedVisioReviewsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/admin': {
      id: '/_authenticated/visio-reviews/admin'
      path: '/visio-reviews/admin'
      fullPath: '/visio-reviews/admin'
      preLoaderRoute: typeof AuthenticatedVisioReviewsAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/boutique': {
      id: '/_authenticated/visio-reviews/boutique'
      path: '/visio-reviews/boutique'
      fullPath: '/visio-reviews/boutique'
      preLoaderRoute: typeof AuthenticatedVisioReviewsBoutiqueRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/evaluation': {
      id: '/_authenticated/visio-reviews/evaluation'
      path: '/visio-reviews/evaluation'
      fullPath: '/visio-reviews/evaluation'
      preLoaderRoute: typeof AuthenticatedVisioReviewsEvaluationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/global': {
      id: '/_authenticated/visio-reviews/global'
      path: '/visio-reviews/global'
      fullPath: '/visio-reviews/global'
      preLoaderRoute: typeof AuthenticatedVisioReviewsGlobalRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/operateur': {
      id: '/_authenticated/visio-reviews/operateur'
      path: '/visio-reviews/operateur'
      fullPath: '/visio-reviews/operateur'
      preLoaderRoute: typeof AuthenticatedVisioReviewsOperateurRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/veille': {
      id: '/_authenticated/visio-reviews/veille'
      path: '/visio-reviews/veille'
      fullPath: '/visio-reviews/veille'
      preLoaderRoute: typeof AuthenticatedVisioReviewsVeilleRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_nosidebar/workshift-attendance/$storeId': {
      id: '/_nosidebar/workshift-attendance/$storeId'
      path: '/workshift-attendance/$storeId'
      fullPath: '/workshift-attendance/$storeId'
      preLoaderRoute: typeof NosidebarWorkshiftAttendanceStoreIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/administration/admins/new': {
      id: '/_authenticated/administration/admins/new'
      path: '/administration/admins/new'
      fullPath: '/administration/admins/new'
      preLoaderRoute: typeof AuthenticatedAdministrationAdminsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/': {
      id: '/_authenticated/administration/roles/'
      path: '/administration/roles'
      fullPath: '/administration/roles/'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/new': {
      id: '/_authenticated/administration/roles/new'
      path: '/administration/roles/new'
      fullPath: '/administration/roles/new'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras-views/$viewId/edit': {
      id: '/_authenticated/cameras-views/$viewId/edit'
      path: '/cameras-views/$viewId/edit'
      fullPath: '/cameras-views/$viewId/edit'
      preLoaderRoute: typeof AuthenticatedCamerasViewsViewIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/$categoryId/edit': {
      id: '/_authenticated/categories/$categoryId/edit'
      path: '/categories/$categoryId/edit'
      fullPath: '/categories/$categoryId/edit'
      preLoaderRoute: typeof AuthenticatedCategoriesCategoryIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/brand/new': {
      id: '/_authenticated/categories/brand/new'
      path: '/categories/brand/new'
      fullPath: '/categories/brand/new'
      preLoaderRoute: typeof AuthenticatedCategoriesBrandNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/internal/': {
      id: '/_authenticated/categories/internal/'
      path: '/categories/internal'
      fullPath: '/categories/internal/'
      preLoaderRoute: typeof AuthenticatedCategoriesInternalIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/internal/new': {
      id: '/_authenticated/categories/internal/new'
      path: '/categories/internal/new'
      fullPath: '/categories/internal/new'
      preLoaderRoute: typeof AuthenticatedCategoriesInternalNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/': {
      id: '/_authenticated/categories/reappro/'
      path: '/categories/reappro'
      fullPath: '/categories/reappro/'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/config': {
      id: '/_authenticated/categories/reappro/config'
      path: '/categories/reappro/config'
      fullPath: '/categories/reappro/config'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproConfigRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/forecast-pilot': {
      id: '/_authenticated/categories/reappro/forecast-pilot'
      path: '/categories/reappro/forecast-pilot'
      fullPath: '/categories/reappro/forecast-pilot'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproForecastPilotRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/new': {
      id: '/_authenticated/categories/reappro/new'
      path: '/categories/reappro/new'
      fullPath: '/categories/reappro/new'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/$id/edit': {
      id: '/_authenticated/companies/$id/edit'
      path: '/companies/$id/edit'
      fullPath: '/companies/$id/edit'
      preLoaderRoute: typeof AuthenticatedCompaniesIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate/': {
      id: '/_authenticated/development/real-estate/'
      path: '/'
      fullPath: '/development/real-estate/'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateIndexRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/calendar': {
      id: '/_authenticated/development/real-estate/calendar'
      path: '/calendar'
      fullPath: '/development/real-estate/calendar'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateCalendarRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/cartes-validees': {
      id: '/_authenticated/development/real-estate/cartes-validees'
      path: '/cartes-validees'
      fullPath: '/development/real-estate/cartes-validees'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateCartesValideesRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/contacts': {
      id: '/_authenticated/development/real-estate/contacts'
      path: '/contacts'
      fullPath: '/development/real-estate/contacts'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateContactsRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/interest-zones': {
      id: '/_authenticated/development/real-estate/interest-zones'
      path: '/interest-zones'
      fullPath: '/development/real-estate/interest-zones'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateInterestZonesRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/kanban': {
      id: '/_authenticated/development/real-estate/kanban'
      path: '/kanban'
      fullPath: '/development/real-estate/kanban'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/map': {
      id: '/_authenticated/development/real-estate/map'
      path: '/map'
      fullPath: '/development/real-estate/map'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateMapRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/development/real-estate/tasks': {
      id: '/_authenticated/development/real-estate/tasks'
      path: '/tasks'
      fullPath: '/development/real-estate/tasks'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateTasksRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateRoute
    }
    '/_authenticated/hr/planning/': {
      id: '/_authenticated/hr/planning/'
      path: '/'
      fullPath: '/hr/planning/'
      preLoaderRoute: typeof AuthenticatedHrPlanningIndexRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/hr/planning/absence-calendar': {
      id: '/_authenticated/hr/planning/absence-calendar'
      path: '/absence-calendar'
      fullPath: '/hr/planning/absence-calendar'
      preLoaderRoute: typeof AuthenticatedHrPlanningAbsenceCalendarRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/hr/planning/attendance': {
      id: '/_authenticated/hr/planning/attendance'
      path: '/attendance'
      fullPath: '/hr/planning/attendance'
      preLoaderRoute: typeof AuthenticatedHrPlanningAttendanceRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/hr/planning/calendar': {
      id: '/_authenticated/hr/planning/calendar'
      path: '/calendar'
      fullPath: '/hr/planning/calendar'
      preLoaderRoute: typeof AuthenticatedHrPlanningCalendarRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/hr/planning/collaborators': {
      id: '/_authenticated/hr/planning/collaborators'
      path: '/collaborators'
      fullPath: '/hr/planning/collaborators'
      preLoaderRoute: typeof AuthenticatedHrPlanningCollaboratorsRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/hr/planning/dashboard': {
      id: '/_authenticated/hr/planning/dashboard'
      path: '/dashboard'
      fullPath: '/hr/planning/dashboard'
      preLoaderRoute: typeof AuthenticatedHrPlanningDashboardRouteImport
      parentRoute: typeof AuthenticatedHrPlanningRoute
    }
    '/_authenticated/logistics/collaborators/$collaboratorId': {
      id: '/_authenticated/logistics/collaborators/$collaboratorId'
      path: '/logistics/collaborators/$collaboratorId'
      fullPath: '/logistics/collaborators/$collaboratorId'
      preLoaderRoute: typeof AuthenticatedLogisticsCollaboratorsCollaboratorIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/collaborators/new': {
      id: '/_authenticated/logistics/collaborators/new'
      path: '/logistics/collaborators/new'
      fullPath: '/logistics/collaborators/new'
      preLoaderRoute: typeof AuthenticatedLogisticsCollaboratorsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/hubs/$hubId': {
      id: '/_authenticated/logistics/hubs/$hubId'
      path: '/logistics/hubs/$hubId'
      fullPath: '/logistics/hubs/$hubId'
      preLoaderRoute: typeof AuthenticatedLogisticsHubsHubIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/hubs/new': {
      id: '/_authenticated/logistics/hubs/new'
      path: '/logistics/hubs/new'
      fullPath: '/logistics/hubs/new'
      preLoaderRoute: typeof AuthenticatedLogisticsHubsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/simulations/$simulationId': {
      id: '/_authenticated/logistics/simulations/$simulationId'
      path: '/logistics/simulations/$simulationId'
      fullPath: '/logistics/simulations/$simulationId'
      preLoaderRoute: typeof AuthenticatedLogisticsSimulationsSimulationIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/vehicles/$vehicleId': {
      id: '/_authenticated/logistics/vehicles/$vehicleId'
      path: '/logistics/vehicles/$vehicleId'
      fullPath: '/logistics/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedLogisticsVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/logistics/vehicles/new': {
      id: '/_authenticated/logistics/vehicles/new'
      path: '/logistics/vehicles/new'
      fullPath: '/logistics/vehicles/new'
      preLoaderRoute: typeof AuthenticatedLogisticsVehiclesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pre-authorizations/$sessionId/recordings': {
      id: '/_authenticated/pre-authorizations/$sessionId/recordings'
      path: '/pre-authorizations/$sessionId/recordings'
      fullPath: '/pre-authorizations/$sessionId/recordings'
      preLoaderRoute: typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/$productId/': {
      id: '/_authenticated/products/$productId/'
      path: '/products/$productId'
      fullPath: '/products/$productId/'
      preLoaderRoute: typeof AuthenticatedProductsProductIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/$productId/edit': {
      id: '/_authenticated/products/$productId/edit'
      path: '/products/$productId/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof AuthenticatedProductsProductIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/$sellerId/edit': {
      id: '/_authenticated/sellers/$sellerId/edit'
      path: '/sellers/$sellerId/edit'
      fullPath: '/sellers/$sellerId/edit'
      preLoaderRoute: typeof AuthenticatedSellersSellerIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/establishment/new': {
      id: '/_authenticated/sellers/establishment/new'
      path: '/sellers/establishment/new'
      fullPath: '/sellers/establishment/new'
      preLoaderRoute: typeof AuthenticatedSellersEstablishmentNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/fridge/new': {
      id: '/_authenticated/sensors/fridge/new'
      path: '/sensors/fridge/new'
      fullPath: '/sensors/fridge/new'
      preLoaderRoute: typeof AuthenticatedSensorsFridgeNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/service-client/tickets/$id': {
      id: '/_authenticated/service-client/tickets/$id'
      path: '/service-client/tickets/$id'
      fullPath: '/service-client/tickets/$id'
      preLoaderRoute: typeof AuthenticatedServiceClientTicketsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/': {
      id: '/_authenticated/stores/$storeId/'
      path: '/stores/$storeId'
      fullPath: '/stores/$storeId/'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/details': {
      id: '/_authenticated/stores/$storeId/details'
      path: '/stores/$storeId/details'
      fullPath: '/stores/$storeId/details'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdDetailsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/hours': {
      id: '/_authenticated/stores/$storeId/hours'
      path: '/stores/$storeId/hours'
      fullPath: '/stores/$storeId/hours'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdHoursRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/inventory': {
      id: '/_authenticated/stores/$storeId/inventory'
      path: '/stores/$storeId/inventory'
      fullPath: '/stores/$storeId/inventory'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdInventoryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/kiosks': {
      id: '/_authenticated/stores/$storeId/kiosks'
      path: '/stores/$storeId/kiosks'
      fullPath: '/stores/$storeId/kiosks'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdKiosksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/stats': {
      id: '/_authenticated/stores/$storeId/stats'
      path: '/stores/$storeId/stats'
      fullPath: '/stores/$storeId/stats'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdStatsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/edit/$userId': {
      id: '/_authenticated/users/edit/$userId'
      path: '/users/edit/$userId'
      fullPath: '/users/edit/$userId'
      preLoaderRoute: typeof AuthenticatedUsersEditUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/admins/$id/edit': {
      id: '/_authenticated/administration/admins/$id/edit'
      path: '/administration/admins/$id/edit'
      fullPath: '/administration/admins/$id/edit'
      preLoaderRoute: typeof AuthenticatedAdministrationAdminsIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/$roleId/': {
      id: '/_authenticated/administration/roles/$roleId/'
      path: '/administration/roles/$roleId'
      fullPath: '/administration/roles/$roleId/'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesRoleIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/$roleId/edit': {
      id: '/_authenticated/administration/roles/$roleId/edit'
      path: '/administration/roles/$roleId/edit'
      fullPath: '/administration/roles/$roleId/edit'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesRoleIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/brand/$brandId/edit': {
      id: '/_authenticated/categories/brand/$brandId/edit'
      path: '/categories/brand/$brandId/edit'
      fullPath: '/categories/brand/$brandId/edit'
      preLoaderRoute: typeof AuthenticatedCategoriesBrandBrandIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/forecast-pilot_/daily-review': {
      id: '/_authenticated/categories/reappro/forecast-pilot_/daily-review'
      path: '/categories/reappro/forecast-pilot/daily-review'
      fullPath: '/categories/reappro/forecast-pilot/daily-review'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproForecastPilotDailyReviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId': {
      id: '/_authenticated/development/real-estate/kanban/$cardId'
      path: '/$cardId'
      fullPath: '/development/real-estate/kanban/$cardId'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanRoute
    }
    '/_authenticated/hr/planning/collaborators/$collaboratorId': {
      id: '/_authenticated/hr/planning/collaborators/$collaboratorId'
      path: '/$collaboratorId'
      fullPath: '/hr/planning/collaborators/$collaboratorId'
      preLoaderRoute: typeof AuthenticatedHrPlanningCollaboratorsCollaboratorIdRouteImport
      parentRoute: typeof AuthenticatedHrPlanningCollaboratorsRoute
    }
    '/_authenticated/sellers/establishment/$establishmentId/edit': {
      id: '/_authenticated/sellers/establishment/$establishmentId/edit'
      path: '/sellers/establishment/$establishmentId/edit'
      fullPath: '/sellers/establishment/$establishmentId/edit'
      preLoaderRoute: typeof AuthenticatedSellersEstablishmentEstablishmentIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/inventories/': {
      id: '/_authenticated/stores/$storeId/inventories/'
      path: '/stores/$storeId/inventories'
      fullPath: '/stores/$storeId/inventories/'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdInventoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/inventories/$inventoryId': {
      id: '/_authenticated/stores/$storeId/inventories/$inventoryId'
      path: '/stores/$storeId/inventories/$inventoryId'
      fullPath: '/stores/$storeId/inventories/$inventoryId'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/stocks/': {
      id: '/_authenticated/stores/$storeId/stocks/'
      path: '/stores/$storeId/stocks'
      fullPath: '/stores/$storeId/stocks/'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdStocksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/'
      path: '/'
      fullPath: '/development/real-estate/kanban/$cardId/'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/admin-authorizations': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/admin-authorizations'
      path: '/admin-authorizations'
      fullPath: '/development/real-estate/kanban/$cardId/admin-authorizations'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/analytics': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/analytics'
      path: '/analytics'
      fullPath: '/development/real-estate/kanban/$cardId/analytics'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/documents': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/documents'
      path: '/documents'
      fullPath: '/development/real-estate/kanban/$cardId/documents'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/general': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/general'
      path: '/general'
      fullPath: '/development/real-estate/kanban/$cardId/general'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/land-commitment': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/land-commitment'
      path: '/land-commitment'
      fullPath: '/development/real-estate/kanban/$cardId/land-commitment'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/development/real-estate/kanban/$cardId/works': {
      id: '/_authenticated/development/real-estate/kanban/$cardId/works'
      path: '/works'
      fullPath: '/development/real-estate/kanban/$cardId/works'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRouteImport
      parentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRoute
    }
    '/_authenticated/stores/$storeId/stocks/product/$productId': {
      id: '/_authenticated/stores/$storeId/stocks/product/$productId'
      path: '/stores/$storeId/stocks/product/$productId'
      fullPath: '/stores/$storeId/stocks/product/$productId'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdStocksProductProductIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedCamerasRouteRouteChildren {
  AuthenticatedCamerasConfigRoute: typeof AuthenticatedCamerasConfigRoute
  AuthenticatedCamerasNewRoute: typeof AuthenticatedCamerasNewRoute
  AuthenticatedCamerasIndexRoute: typeof AuthenticatedCamerasIndexRoute
}

const AuthenticatedCamerasRouteRouteChildren: AuthenticatedCamerasRouteRouteChildren =
  {
    AuthenticatedCamerasConfigRoute: AuthenticatedCamerasConfigRoute,
    AuthenticatedCamerasNewRoute: AuthenticatedCamerasNewRoute,
    AuthenticatedCamerasIndexRoute: AuthenticatedCamerasIndexRoute,
  }

const AuthenticatedCamerasRouteRouteWithChildren =
  AuthenticatedCamerasRouteRoute._addFileChildren(
    AuthenticatedCamerasRouteRouteChildren,
  )

interface AuthenticatedInventoriesRouteRouteChildren {
  AuthenticatedInventoriesStoreIdRoute: typeof AuthenticatedInventoriesStoreIdRoute
}

const AuthenticatedInventoriesRouteRouteChildren: AuthenticatedInventoriesRouteRouteChildren =
  {
    AuthenticatedInventoriesStoreIdRoute: AuthenticatedInventoriesStoreIdRoute,
  }

const AuthenticatedInventoriesRouteRouteWithChildren =
  AuthenticatedInventoriesRouteRoute._addFileChildren(
    AuthenticatedInventoriesRouteRouteChildren,
  )

interface AuthenticatedDevelopmentRealEstateKanbanCardIdRouteChildren {
  AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute
  AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute
}

const AuthenticatedDevelopmentRealEstateKanbanCardIdRouteChildren: AuthenticatedDevelopmentRealEstateKanbanCardIdRouteChildren =
  {
    AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdAdminAuthorizationsRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdAnalyticsRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdDocumentsRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdGeneralRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdLandCommitmentRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdWorksRoute,
    AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdIndexRoute,
  }

const AuthenticatedDevelopmentRealEstateKanbanCardIdRouteWithChildren =
  AuthenticatedDevelopmentRealEstateKanbanCardIdRoute._addFileChildren(
    AuthenticatedDevelopmentRealEstateKanbanCardIdRouteChildren,
  )

interface AuthenticatedDevelopmentRealEstateKanbanRouteChildren {
  AuthenticatedDevelopmentRealEstateKanbanCardIdRoute: typeof AuthenticatedDevelopmentRealEstateKanbanCardIdRouteWithChildren
}

const AuthenticatedDevelopmentRealEstateKanbanRouteChildren: AuthenticatedDevelopmentRealEstateKanbanRouteChildren =
  {
    AuthenticatedDevelopmentRealEstateKanbanCardIdRoute:
      AuthenticatedDevelopmentRealEstateKanbanCardIdRouteWithChildren,
  }

const AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren =
  AuthenticatedDevelopmentRealEstateKanbanRoute._addFileChildren(
    AuthenticatedDevelopmentRealEstateKanbanRouteChildren,
  )

interface AuthenticatedDevelopmentRealEstateRouteChildren {
  AuthenticatedDevelopmentRealEstateCalendarRoute: typeof AuthenticatedDevelopmentRealEstateCalendarRoute
  AuthenticatedDevelopmentRealEstateCartesValideesRoute: typeof AuthenticatedDevelopmentRealEstateCartesValideesRoute
  AuthenticatedDevelopmentRealEstateContactsRoute: typeof AuthenticatedDevelopmentRealEstateContactsRoute
  AuthenticatedDevelopmentRealEstateInterestZonesRoute: typeof AuthenticatedDevelopmentRealEstateInterestZonesRoute
  AuthenticatedDevelopmentRealEstateKanbanRoute: typeof AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren
  AuthenticatedDevelopmentRealEstateMapRoute: typeof AuthenticatedDevelopmentRealEstateMapRoute
  AuthenticatedDevelopmentRealEstateTasksRoute: typeof AuthenticatedDevelopmentRealEstateTasksRoute
  AuthenticatedDevelopmentRealEstateIndexRoute: typeof AuthenticatedDevelopmentRealEstateIndexRoute
}

const AuthenticatedDevelopmentRealEstateRouteChildren: AuthenticatedDevelopmentRealEstateRouteChildren =
  {
    AuthenticatedDevelopmentRealEstateCalendarRoute:
      AuthenticatedDevelopmentRealEstateCalendarRoute,
    AuthenticatedDevelopmentRealEstateCartesValideesRoute:
      AuthenticatedDevelopmentRealEstateCartesValideesRoute,
    AuthenticatedDevelopmentRealEstateContactsRoute:
      AuthenticatedDevelopmentRealEstateContactsRoute,
    AuthenticatedDevelopmentRealEstateInterestZonesRoute:
      AuthenticatedDevelopmentRealEstateInterestZonesRoute,
    AuthenticatedDevelopmentRealEstateKanbanRoute:
      AuthenticatedDevelopmentRealEstateKanbanRouteWithChildren,
    AuthenticatedDevelopmentRealEstateMapRoute:
      AuthenticatedDevelopmentRealEstateMapRoute,
    AuthenticatedDevelopmentRealEstateTasksRoute:
      AuthenticatedDevelopmentRealEstateTasksRoute,
    AuthenticatedDevelopmentRealEstateIndexRoute:
      AuthenticatedDevelopmentRealEstateIndexRoute,
  }

const AuthenticatedDevelopmentRealEstateRouteWithChildren =
  AuthenticatedDevelopmentRealEstateRoute._addFileChildren(
    AuthenticatedDevelopmentRealEstateRouteChildren,
  )

interface AuthenticatedHrPlanningCollaboratorsRouteChildren {
  AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute: typeof AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute
}

const AuthenticatedHrPlanningCollaboratorsRouteChildren: AuthenticatedHrPlanningCollaboratorsRouteChildren =
  {
    AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute:
      AuthenticatedHrPlanningCollaboratorsCollaboratorIdRoute,
  }

const AuthenticatedHrPlanningCollaboratorsRouteWithChildren =
  AuthenticatedHrPlanningCollaboratorsRoute._addFileChildren(
    AuthenticatedHrPlanningCollaboratorsRouteChildren,
  )

interface AuthenticatedHrPlanningRouteChildren {
  AuthenticatedHrPlanningAbsenceCalendarRoute: typeof AuthenticatedHrPlanningAbsenceCalendarRoute
  AuthenticatedHrPlanningAttendanceRoute: typeof AuthenticatedHrPlanningAttendanceRoute
  AuthenticatedHrPlanningCalendarRoute: typeof AuthenticatedHrPlanningCalendarRoute
  AuthenticatedHrPlanningCollaboratorsRoute: typeof AuthenticatedHrPlanningCollaboratorsRouteWithChildren
  AuthenticatedHrPlanningDashboardRoute: typeof AuthenticatedHrPlanningDashboardRoute
  AuthenticatedHrPlanningIndexRoute: typeof AuthenticatedHrPlanningIndexRoute
}

const AuthenticatedHrPlanningRouteChildren: AuthenticatedHrPlanningRouteChildren =
  {
    AuthenticatedHrPlanningAbsenceCalendarRoute:
      AuthenticatedHrPlanningAbsenceCalendarRoute,
    AuthenticatedHrPlanningAttendanceRoute:
      AuthenticatedHrPlanningAttendanceRoute,
    AuthenticatedHrPlanningCalendarRoute: AuthenticatedHrPlanningCalendarRoute,
    AuthenticatedHrPlanningCollaboratorsRoute:
      AuthenticatedHrPlanningCollaboratorsRouteWithChildren,
    AuthenticatedHrPlanningDashboardRoute:
      AuthenticatedHrPlanningDashboardRoute,
    AuthenticatedHrPlanningIndexRoute: AuthenticatedHrPlanningIndexRoute,
  }

const AuthenticatedHrPlanningRouteWithChildren =
  AuthenticatedHrPlanningRoute._addFileChildren(
    AuthenticatedHrPlanningRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCamerasRouteRoute: typeof AuthenticatedCamerasRouteRouteWithChildren
  AuthenticatedInventoriesRouteRoute: typeof AuthenticatedInventoriesRouteRouteWithChildren
  AuthenticatedAccountingRoute: typeof AuthenticatedAccountingRoute
  AuthenticatedCartPhotosX7k2qzRoute: typeof AuthenticatedCartPhotosX7k2qzRoute
  AuthenticatedCartVisionChecksRoute: typeof AuthenticatedCartVisionChecksRoute
  AuthenticatedCartsRoute: typeof AuthenticatedCartsRoute
  AuthenticatedCartsControlRoute: typeof AuthenticatedCartsControlRoute
  AuthenticatedCpiInventoryRoute: typeof AuthenticatedCpiInventoryRoute
  AuthenticatedIndustrialConfiguratorRoute: typeof AuthenticatedIndustrialConfiguratorRoute
  AuthenticatedStagingToolsRoute: typeof AuthenticatedStagingToolsRoute
  AuthenticatedStoreAppPreviewRoute: typeof AuthenticatedStoreAppPreviewRoute
  AuthenticatedTodayRoute: typeof AuthenticatedTodayRoute
  AuthenticatedAdministrationAccessRoute: typeof AuthenticatedAdministrationAccessRoute
  AuthenticatedCamerasViewsNewRoute: typeof AuthenticatedCamerasViewsNewRoute
  AuthenticatedCategoriesBrandsRoute: typeof AuthenticatedCategoriesBrandsRoute
  AuthenticatedCategoriesCategoriesRoute: typeof AuthenticatedCategoriesCategoriesRoute
  AuthenticatedCategoriesNewRoute: typeof AuthenticatedCategoriesNewRoute
  AuthenticatedCompaniesNewRoute: typeof AuthenticatedCompaniesNewRoute
  AuthenticatedDashboardHoursRoute: typeof AuthenticatedDashboardHoursRoute
  AuthenticatedDevelopmentMapCompareRoute: typeof AuthenticatedDevelopmentMapCompareRoute
  AuthenticatedDevelopmentRealEstateRoute: typeof AuthenticatedDevelopmentRealEstateRouteWithChildren
  AuthenticatedHrCollaboratorsRoute: typeof AuthenticatedHrCollaboratorsRoute
  AuthenticatedHrInterimAgenciesRoute: typeof AuthenticatedHrInterimAgenciesRoute
  AuthenticatedHrPlanningRoute: typeof AuthenticatedHrPlanningRouteWithChildren
  AuthenticatedHrSmsTrackingRoute: typeof AuthenticatedHrSmsTrackingRoute
  AuthenticatedMailingListsKeyRoute: typeof AuthenticatedMailingListsKeyRoute
  AuthenticatedNotificationsIdRoute: typeof AuthenticatedNotificationsIdRoute
  AuthenticatedNotificationsNewRoute: typeof AuthenticatedNotificationsNewRoute
  AuthenticatedProductsImportRoute: typeof AuthenticatedProductsImportRoute
  AuthenticatedProductsNewRoute: typeof AuthenticatedProductsNewRoute
  AuthenticatedPromoCampaignNewRoute: typeof AuthenticatedPromoCampaignNewRoute
  AuthenticatedQualityLotRoute: typeof AuthenticatedQualityLotRoute
  AuthenticatedQualityArticlesRoute: typeof AuthenticatedQualityArticlesRoute
  AuthenticatedQualityLotsRoute: typeof AuthenticatedQualityLotsRoute
  AuthenticatedSellersEstablishmentsRoute: typeof AuthenticatedSellersEstablishmentsRoute
  AuthenticatedSellersNewRoute: typeof AuthenticatedSellersNewRoute
  AuthenticatedSellersSellersRoute: typeof AuthenticatedSellersSellersRoute
  AuthenticatedSensorsNewRoute: typeof AuthenticatedSensorsNewRoute
  AuthenticatedStoresNewRoute: typeof AuthenticatedStoresNewRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedUsersAppRoute: typeof AuthenticatedUsersAppRoute
  AuthenticatedUsersBoRoute: typeof AuthenticatedUsersBoRoute
  AuthenticatedUsersPaymentDefaultsRoute: typeof AuthenticatedUsersPaymentDefaultsRoute
  AuthenticatedUsersPaymentLinksRoute: typeof AuthenticatedUsersPaymentLinksRoute
  AuthenticatedVisioReviewsAdminRoute: typeof AuthenticatedVisioReviewsAdminRoute
  AuthenticatedVisioReviewsBoutiqueRoute: typeof AuthenticatedVisioReviewsBoutiqueRoute
  AuthenticatedVisioReviewsEvaluationRoute: typeof AuthenticatedVisioReviewsEvaluationRoute
  AuthenticatedVisioReviewsGlobalRoute: typeof AuthenticatedVisioReviewsGlobalRoute
  AuthenticatedVisioReviewsOperateurRoute: typeof AuthenticatedVisioReviewsOperateurRoute
  AuthenticatedVisioReviewsVeilleRoute: typeof AuthenticatedVisioReviewsVeilleRoute
  AuthenticatedCamerasViewsIndexRoute: typeof AuthenticatedCamerasViewsIndexRoute
  AuthenticatedCategoriesIndexRoute: typeof AuthenticatedCategoriesIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedControleRuptureIndexRoute: typeof AuthenticatedControleRuptureIndexRoute
  AuthenticatedCorrectionRupturesIndexRoute: typeof AuthenticatedCorrectionRupturesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedLogisticsIndexRoute: typeof AuthenticatedLogisticsIndexRoute
  AuthenticatedMailingListsIndexRoute: typeof AuthenticatedMailingListsIndexRoute
  AuthenticatedNetworkDashboardIndexRoute: typeof AuthenticatedNetworkDashboardIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedPlatformStocksIndexRoute: typeof AuthenticatedPlatformStocksIndexRoute
  AuthenticatedPreAuthorizationsIndexRoute: typeof AuthenticatedPreAuthorizationsIndexRoute
  AuthenticatedPrevisionsCategoriesIndexRoute: typeof AuthenticatedPrevisionsCategoriesIndexRoute
  AuthenticatedPrevisionsLongTermeIndexRoute: typeof AuthenticatedPrevisionsLongTermeIndexRoute
  AuthenticatedPrevisionsProduitsIndexRoute: typeof AuthenticatedPrevisionsProduitsIndexRoute
  AuthenticatedPrevisionsSemaineIndexRoute: typeof AuthenticatedPrevisionsSemaineIndexRoute
  AuthenticatedPrevisionsIndexRoute: typeof AuthenticatedPrevisionsIndexRoute
  AuthenticatedProductManagementIndexRoute: typeof AuthenticatedProductManagementIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedPromoCampaignIndexRoute: typeof AuthenticatedPromoCampaignIndexRoute
  AuthenticatedQualityIndexRoute: typeof AuthenticatedQualityIndexRoute
  AuthenticatedSandboxPrevisionsIndexRoute: typeof AuthenticatedSandboxPrevisionsIndexRoute
  AuthenticatedSellersIndexRoute: typeof AuthenticatedSellersIndexRoute
  AuthenticatedSensorsIndexRoute: typeof AuthenticatedSensorsIndexRoute
  AuthenticatedServiceClientIndexRoute: typeof AuthenticatedServiceClientIndexRoute
  AuthenticatedStoreAppTodoIndexRoute: typeof AuthenticatedStoreAppTodoIndexRoute
  AuthenticatedStoresIndexRoute: typeof AuthenticatedStoresIndexRoute
  AuthenticatedSupplyIndexRoute: typeof AuthenticatedSupplyIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVacancesScolairesIndexRoute: typeof AuthenticatedVacancesScolairesIndexRoute
  AuthenticatedVisioReviewsIndexRoute: typeof AuthenticatedVisioReviewsIndexRoute
  AuthenticatedAdministrationAdminsNewRoute: typeof AuthenticatedAdministrationAdminsNewRoute
  AuthenticatedAdministrationRolesNewRoute: typeof AuthenticatedAdministrationRolesNewRoute
  AuthenticatedCamerasViewsViewIdEditRoute: typeof AuthenticatedCamerasViewsViewIdEditRoute
  AuthenticatedCategoriesCategoryIdEditRoute: typeof AuthenticatedCategoriesCategoryIdEditRoute
  AuthenticatedCategoriesBrandNewRoute: typeof AuthenticatedCategoriesBrandNewRoute
  AuthenticatedCategoriesInternalNewRoute: typeof AuthenticatedCategoriesInternalNewRoute
  AuthenticatedCategoriesReapproConfigRoute: typeof AuthenticatedCategoriesReapproConfigRoute
  AuthenticatedCategoriesReapproForecastPilotRoute: typeof AuthenticatedCategoriesReapproForecastPilotRoute
  AuthenticatedCategoriesReapproNewRoute: typeof AuthenticatedCategoriesReapproNewRoute
  AuthenticatedCompaniesIdEditRoute: typeof AuthenticatedCompaniesIdEditRoute
  AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute: typeof AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute
  AuthenticatedLogisticsCollaboratorsNewRoute: typeof AuthenticatedLogisticsCollaboratorsNewRoute
  AuthenticatedLogisticsHubsHubIdRoute: typeof AuthenticatedLogisticsHubsHubIdRoute
  AuthenticatedLogisticsHubsNewRoute: typeof AuthenticatedLogisticsHubsNewRoute
  AuthenticatedLogisticsSimulationsSimulationIdRoute: typeof AuthenticatedLogisticsSimulationsSimulationIdRoute
  AuthenticatedLogisticsVehiclesVehicleIdRoute: typeof AuthenticatedLogisticsVehiclesVehicleIdRoute
  AuthenticatedLogisticsVehiclesNewRoute: typeof AuthenticatedLogisticsVehiclesNewRoute
  AuthenticatedPreAuthorizationsSessionIdRecordingsRoute: typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  AuthenticatedProductsProductIdEditRoute: typeof AuthenticatedProductsProductIdEditRoute
  AuthenticatedSellersSellerIdEditRoute: typeof AuthenticatedSellersSellerIdEditRoute
  AuthenticatedSellersEstablishmentNewRoute: typeof AuthenticatedSellersEstablishmentNewRoute
  AuthenticatedSensorsFridgeNewRoute: typeof AuthenticatedSensorsFridgeNewRoute
  AuthenticatedServiceClientTicketsIdRoute: typeof AuthenticatedServiceClientTicketsIdRoute
  AuthenticatedStoresStoreIdDetailsRoute: typeof AuthenticatedStoresStoreIdDetailsRoute
  AuthenticatedStoresStoreIdHoursRoute: typeof AuthenticatedStoresStoreIdHoursRoute
  AuthenticatedStoresStoreIdInventoryRoute: typeof AuthenticatedStoresStoreIdInventoryRoute
  AuthenticatedStoresStoreIdKiosksRoute: typeof AuthenticatedStoresStoreIdKiosksRoute
  AuthenticatedStoresStoreIdStatsRoute: typeof AuthenticatedStoresStoreIdStatsRoute
  AuthenticatedUsersEditUserIdRoute: typeof AuthenticatedUsersEditUserIdRoute
  AuthenticatedAdministrationRolesIndexRoute: typeof AuthenticatedAdministrationRolesIndexRoute
  AuthenticatedCategoriesInternalIndexRoute: typeof AuthenticatedCategoriesInternalIndexRoute
  AuthenticatedCategoriesReapproIndexRoute: typeof AuthenticatedCategoriesReapproIndexRoute
  AuthenticatedProductsProductIdIndexRoute: typeof AuthenticatedProductsProductIdIndexRoute
  AuthenticatedStoresStoreIdIndexRoute: typeof AuthenticatedStoresStoreIdIndexRoute
  AuthenticatedAdministrationAdminsIdEditRoute: typeof AuthenticatedAdministrationAdminsIdEditRoute
  AuthenticatedAdministrationRolesRoleIdEditRoute: typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  AuthenticatedCategoriesBrandBrandIdEditRoute: typeof AuthenticatedCategoriesBrandBrandIdEditRoute
  AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute: typeof AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute
  AuthenticatedSellersEstablishmentEstablishmentIdEditRoute: typeof AuthenticatedSellersEstablishmentEstablishmentIdEditRoute
  AuthenticatedStoresStoreIdInventoriesInventoryIdRoute: typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  AuthenticatedAdministrationRolesRoleIdIndexRoute: typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
  AuthenticatedStoresStoreIdInventoriesIndexRoute: typeof AuthenticatedStoresStoreIdInventoriesIndexRoute
  AuthenticatedStoresStoreIdStocksIndexRoute: typeof AuthenticatedStoresStoreIdStocksIndexRoute
  AuthenticatedStoresStoreIdStocksProductProductIdRoute: typeof AuthenticatedStoresStoreIdStocksProductProductIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCamerasRouteRoute: AuthenticatedCamerasRouteRouteWithChildren,
  AuthenticatedInventoriesRouteRoute:
    AuthenticatedInventoriesRouteRouteWithChildren,
  AuthenticatedAccountingRoute: AuthenticatedAccountingRoute,
  AuthenticatedCartPhotosX7k2qzRoute: AuthenticatedCartPhotosX7k2qzRoute,
  AuthenticatedCartVisionChecksRoute: AuthenticatedCartVisionChecksRoute,
  AuthenticatedCartsRoute: AuthenticatedCartsRoute,
  AuthenticatedCartsControlRoute: AuthenticatedCartsControlRoute,
  AuthenticatedCpiInventoryRoute: AuthenticatedCpiInventoryRoute,
  AuthenticatedIndustrialConfiguratorRoute:
    AuthenticatedIndustrialConfiguratorRoute,
  AuthenticatedStagingToolsRoute: AuthenticatedStagingToolsRoute,
  AuthenticatedStoreAppPreviewRoute: AuthenticatedStoreAppPreviewRoute,
  AuthenticatedTodayRoute: AuthenticatedTodayRoute,
  AuthenticatedAdministrationAccessRoute:
    AuthenticatedAdministrationAccessRoute,
  AuthenticatedCamerasViewsNewRoute: AuthenticatedCamerasViewsNewRoute,
  AuthenticatedCategoriesBrandsRoute: AuthenticatedCategoriesBrandsRoute,
  AuthenticatedCategoriesCategoriesRoute:
    AuthenticatedCategoriesCategoriesRoute,
  AuthenticatedCategoriesNewRoute: AuthenticatedCategoriesNewRoute,
  AuthenticatedCompaniesNewRoute: AuthenticatedCompaniesNewRoute,
  AuthenticatedDashboardHoursRoute: AuthenticatedDashboardHoursRoute,
  AuthenticatedDevelopmentMapCompareRoute:
    AuthenticatedDevelopmentMapCompareRoute,
  AuthenticatedDevelopmentRealEstateRoute:
    AuthenticatedDevelopmentRealEstateRouteWithChildren,
  AuthenticatedHrCollaboratorsRoute: AuthenticatedHrCollaboratorsRoute,
  AuthenticatedHrInterimAgenciesRoute: AuthenticatedHrInterimAgenciesRoute,
  AuthenticatedHrPlanningRoute: AuthenticatedHrPlanningRouteWithChildren,
  AuthenticatedHrSmsTrackingRoute: AuthenticatedHrSmsTrackingRoute,
  AuthenticatedMailingListsKeyRoute: AuthenticatedMailingListsKeyRoute,
  AuthenticatedNotificationsIdRoute: AuthenticatedNotificationsIdRoute,
  AuthenticatedNotificationsNewRoute: AuthenticatedNotificationsNewRoute,
  AuthenticatedProductsImportRoute: AuthenticatedProductsImportRoute,
  AuthenticatedProductsNewRoute: AuthenticatedProductsNewRoute,
  AuthenticatedPromoCampaignNewRoute: AuthenticatedPromoCampaignNewRoute,
  AuthenticatedQualityLotRoute: AuthenticatedQualityLotRoute,
  AuthenticatedQualityArticlesRoute: AuthenticatedQualityArticlesRoute,
  AuthenticatedQualityLotsRoute: AuthenticatedQualityLotsRoute,
  AuthenticatedSellersEstablishmentsRoute:
    AuthenticatedSellersEstablishmentsRoute,
  AuthenticatedSellersNewRoute: AuthenticatedSellersNewRoute,
  AuthenticatedSellersSellersRoute: AuthenticatedSellersSellersRoute,
  AuthenticatedSensorsNewRoute: AuthenticatedSensorsNewRoute,
  AuthenticatedStoresNewRoute: AuthenticatedStoresNewRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedUsersAppRoute: AuthenticatedUsersAppRoute,
  AuthenticatedUsersBoRoute: AuthenticatedUsersBoRoute,
  AuthenticatedUsersPaymentDefaultsRoute:
    AuthenticatedUsersPaymentDefaultsRoute,
  AuthenticatedUsersPaymentLinksRoute: AuthenticatedUsersPaymentLinksRoute,
  AuthenticatedVisioReviewsAdminRoute: AuthenticatedVisioReviewsAdminRoute,
  AuthenticatedVisioReviewsBoutiqueRoute:
    AuthenticatedVisioReviewsBoutiqueRoute,
  AuthenticatedVisioReviewsEvaluationRoute:
    AuthenticatedVisioReviewsEvaluationRoute,
  AuthenticatedVisioReviewsGlobalRoute: AuthenticatedVisioReviewsGlobalRoute,
  AuthenticatedVisioReviewsOperateurRoute:
    AuthenticatedVisioReviewsOperateurRoute,
  AuthenticatedVisioReviewsVeilleRoute: AuthenticatedVisioReviewsVeilleRoute,
  AuthenticatedCamerasViewsIndexRoute: AuthenticatedCamerasViewsIndexRoute,
  AuthenticatedCategoriesIndexRoute: AuthenticatedCategoriesIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedControleRuptureIndexRoute:
    AuthenticatedControleRuptureIndexRoute,
  AuthenticatedCorrectionRupturesIndexRoute:
    AuthenticatedCorrectionRupturesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedLogisticsIndexRoute: AuthenticatedLogisticsIndexRoute,
  AuthenticatedMailingListsIndexRoute: AuthenticatedMailingListsIndexRoute,
  AuthenticatedNetworkDashboardIndexRoute:
    AuthenticatedNetworkDashboardIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedPlatformStocksIndexRoute: AuthenticatedPlatformStocksIndexRoute,
  AuthenticatedPreAuthorizationsIndexRoute:
    AuthenticatedPreAuthorizationsIndexRoute,
  AuthenticatedPrevisionsCategoriesIndexRoute:
    AuthenticatedPrevisionsCategoriesIndexRoute,
  AuthenticatedPrevisionsLongTermeIndexRoute:
    AuthenticatedPrevisionsLongTermeIndexRoute,
  AuthenticatedPrevisionsProduitsIndexRoute:
    AuthenticatedPrevisionsProduitsIndexRoute,
  AuthenticatedPrevisionsSemaineIndexRoute:
    AuthenticatedPrevisionsSemaineIndexRoute,
  AuthenticatedPrevisionsIndexRoute: AuthenticatedPrevisionsIndexRoute,
  AuthenticatedProductManagementIndexRoute:
    AuthenticatedProductManagementIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedPromoCampaignIndexRoute: AuthenticatedPromoCampaignIndexRoute,
  AuthenticatedQualityIndexRoute: AuthenticatedQualityIndexRoute,
  AuthenticatedSandboxPrevisionsIndexRoute:
    AuthenticatedSandboxPrevisionsIndexRoute,
  AuthenticatedSellersIndexRoute: AuthenticatedSellersIndexRoute,
  AuthenticatedSensorsIndexRoute: AuthenticatedSensorsIndexRoute,
  AuthenticatedServiceClientIndexRoute: AuthenticatedServiceClientIndexRoute,
  AuthenticatedStoreAppTodoIndexRoute: AuthenticatedStoreAppTodoIndexRoute,
  AuthenticatedStoresIndexRoute: AuthenticatedStoresIndexRoute,
  AuthenticatedSupplyIndexRoute: AuthenticatedSupplyIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVacancesScolairesIndexRoute:
    AuthenticatedVacancesScolairesIndexRoute,
  AuthenticatedVisioReviewsIndexRoute: AuthenticatedVisioReviewsIndexRoute,
  AuthenticatedAdministrationAdminsNewRoute:
    AuthenticatedAdministrationAdminsNewRoute,
  AuthenticatedAdministrationRolesNewRoute:
    AuthenticatedAdministrationRolesNewRoute,
  AuthenticatedCamerasViewsViewIdEditRoute:
    AuthenticatedCamerasViewsViewIdEditRoute,
  AuthenticatedCategoriesCategoryIdEditRoute:
    AuthenticatedCategoriesCategoryIdEditRoute,
  AuthenticatedCategoriesBrandNewRoute: AuthenticatedCategoriesBrandNewRoute,
  AuthenticatedCategoriesInternalNewRoute:
    AuthenticatedCategoriesInternalNewRoute,
  AuthenticatedCategoriesReapproConfigRoute:
    AuthenticatedCategoriesReapproConfigRoute,
  AuthenticatedCategoriesReapproForecastPilotRoute:
    AuthenticatedCategoriesReapproForecastPilotRoute,
  AuthenticatedCategoriesReapproNewRoute:
    AuthenticatedCategoriesReapproNewRoute,
  AuthenticatedCompaniesIdEditRoute: AuthenticatedCompaniesIdEditRoute,
  AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute:
    AuthenticatedLogisticsCollaboratorsCollaboratorIdRoute,
  AuthenticatedLogisticsCollaboratorsNewRoute:
    AuthenticatedLogisticsCollaboratorsNewRoute,
  AuthenticatedLogisticsHubsHubIdRoute: AuthenticatedLogisticsHubsHubIdRoute,
  AuthenticatedLogisticsHubsNewRoute: AuthenticatedLogisticsHubsNewRoute,
  AuthenticatedLogisticsSimulationsSimulationIdRoute:
    AuthenticatedLogisticsSimulationsSimulationIdRoute,
  AuthenticatedLogisticsVehiclesVehicleIdRoute:
    AuthenticatedLogisticsVehiclesVehicleIdRoute,
  AuthenticatedLogisticsVehiclesNewRoute:
    AuthenticatedLogisticsVehiclesNewRoute,
  AuthenticatedPreAuthorizationsSessionIdRecordingsRoute:
    AuthenticatedPreAuthorizationsSessionIdRecordingsRoute,
  AuthenticatedProductsProductIdEditRoute:
    AuthenticatedProductsProductIdEditRoute,
  AuthenticatedSellersSellerIdEditRoute: AuthenticatedSellersSellerIdEditRoute,
  AuthenticatedSellersEstablishmentNewRoute:
    AuthenticatedSellersEstablishmentNewRoute,
  AuthenticatedSensorsFridgeNewRoute: AuthenticatedSensorsFridgeNewRoute,
  AuthenticatedServiceClientTicketsIdRoute:
    AuthenticatedServiceClientTicketsIdRoute,
  AuthenticatedStoresStoreIdDetailsRoute:
    AuthenticatedStoresStoreIdDetailsRoute,
  AuthenticatedStoresStoreIdHoursRoute: AuthenticatedStoresStoreIdHoursRoute,
  AuthenticatedStoresStoreIdInventoryRoute:
    AuthenticatedStoresStoreIdInventoryRoute,
  AuthenticatedStoresStoreIdKiosksRoute: AuthenticatedStoresStoreIdKiosksRoute,
  AuthenticatedStoresStoreIdStatsRoute: AuthenticatedStoresStoreIdStatsRoute,
  AuthenticatedUsersEditUserIdRoute: AuthenticatedUsersEditUserIdRoute,
  AuthenticatedAdministrationRolesIndexRoute:
    AuthenticatedAdministrationRolesIndexRoute,
  AuthenticatedCategoriesInternalIndexRoute:
    AuthenticatedCategoriesInternalIndexRoute,
  AuthenticatedCategoriesReapproIndexRoute:
    AuthenticatedCategoriesReapproIndexRoute,
  AuthenticatedProductsProductIdIndexRoute:
    AuthenticatedProductsProductIdIndexRoute,
  AuthenticatedStoresStoreIdIndexRoute: AuthenticatedStoresStoreIdIndexRoute,
  AuthenticatedAdministrationAdminsIdEditRoute:
    AuthenticatedAdministrationAdminsIdEditRoute,
  AuthenticatedAdministrationRolesRoleIdEditRoute:
    AuthenticatedAdministrationRolesRoleIdEditRoute,
  AuthenticatedCategoriesBrandBrandIdEditRoute:
    AuthenticatedCategoriesBrandBrandIdEditRoute,
  AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute:
    AuthenticatedCategoriesReapproForecastPilotDailyReviewRoute,
  AuthenticatedSellersEstablishmentEstablishmentIdEditRoute:
    AuthenticatedSellersEstablishmentEstablishmentIdEditRoute,
  AuthenticatedStoresStoreIdInventoriesInventoryIdRoute:
    AuthenticatedStoresStoreIdInventoriesInventoryIdRoute,
  AuthenticatedAdministrationRolesRoleIdIndexRoute:
    AuthenticatedAdministrationRolesRoleIdIndexRoute,
  AuthenticatedStoresStoreIdInventoriesIndexRoute:
    AuthenticatedStoresStoreIdInventoriesIndexRoute,
  AuthenticatedStoresStoreIdStocksIndexRoute:
    AuthenticatedStoresStoreIdStocksIndexRoute,
  AuthenticatedStoresStoreIdStocksProductProductIdRoute:
    AuthenticatedStoresStoreIdStocksProductProductIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  NosidebarPlanningRoute: NosidebarPlanningRoute,
  NosidebarWorkshiftAttendanceStoreIdRoute:
    NosidebarWorkshiftAttendanceStoreIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
